import React, { useEffect, useState, Fragment, useReducer, useRef } from 'react';
import moment from 'moment';
import momentTz from 'moment-timezone';
import { useHistory  } from 'react-router-dom';
import { connect } from 'react-redux';
import Slider from 'react-slick';
import ReactSelect from 'react-select';
import NumericInput from 'react-numeric-input';
import { Modal, OverlayTrigger, Tooltip } from 'react-bootstrap';
import { DatePicker, notification } from 'antd';
import { AES } from 'crypto-js';
import { bookingCamperDetailService, programBookingNeighborsService, getAdditionalExperienceService, productListByBookingSerivce, updateRemainingAmountService, medicalDocumentStatusChangeSerivce, updateBookingDateService, editAllAnsByDirService, updateCommuterService, getRefundInfoService, counselordetail } from '../../services/directorServices';
import { InformationIcon, ProgramLoader } from '../reuse/SVG';
import { getHtml, getSignature, _calculateAge, resHandle, removeTime, calculateProductRefundPrice, calculateProductRefundWithFee, MAX_INSURANCE_PRODUCTS, getCardTypeImage, initialChargeAmountModalState, ChargeAmountReducer, getPriceCategory, calculateInsuranceCamperDisplay, convertTimeToCurrentTimeZone, PaymentDateFormat, notificationMsg, sortByTimestamp, setProgramPrice, formatBookingAuditEntry, getApplicableDocuments } from '../../helper';
import { saveCabinIdAction } from '../../store/ui';
import { camperCancelRefundAction, cancelRefundAction, deleteCardService, getCartProductsService, getCustomerCardsService2, getProgramDetails, markPrimaryCard, refundBookingByCampers, removeFromCart, updateBookingKeyService, updateCartProductsService, sendDocumentReminderService, groupApprovalService } from '../../services/programService';
import { CustomNumber } from '../reuse/FormControls';
import { resendBookingEmailService, uploadMedia } from '../../services/campersServices';
import { getCampDetailService } from '../../services/userServices';
import { addProductIntoCartService, deductPaylaterAmountService, getProductsService } from '../../services/onlineStoreService';
import settings from '../../config/settings';
import ProductPaymentGateway from '../payment/ProductPaymentGateway';
import ShowProductInfo from './ShowProductInfo';
import Addon from '../online-store/Addon';
import QuestionsComponent from '../common/Questions/QuestionsComponent';
import AddInsurance from './AddInsurance';
import {  camperCancellationOptions, cancellationOptions, getColors2, getSizes, getTaxForPrice, getWithTaxPrice, isOnlySpaces, trimSpace } from './bookingHelper';
import { hasCommuterOption } from '../cart/helper';
import ChargeCamperModal from '../reuse/ChargeCamper/ChargeCamperModal';
import PdfViewer from '../common/PdfViewer/PdfViewer';
import AddNewCard from '../payment/AddNewCard';
import SecureInput from '../payment/SecureInput';
import CreditCard from '../payment/CreditCard';
import PaymentDetails from '../payment/PaymentDetails';
import PaymentModal from '../payment/PaymentModal';
import NoteModal from './BookingModals/NoteModal';
import CommuterHistory from './BookingModals/CommuterHistory';
import AddExp, { ConfirmAddExp } from './BookingModals/AddExp';
import AdditionalExpAudit from './BookingModals/AdditionalExpAudit';
import AuditTrail from '../common/AuditTrail/AuditTrail';
import CustomDropDown from '../reuse/UIComponents/CustomDropDown';
import ScheduleEmi from './BookingModals/ScheduleEmi';
import BookingDetailLayout from './camperDetail/BookingDetailLayout';
import BookingHeader from './camperDetail/BookingHeader';
import PrevNextNav from './camperDetail/PrevNextNav';
import ParticipantCard from './camperDetail/ParticipantCard';
import GuardianCard from './camperDetail/GuardianCard';
import QuestionsCard from './camperDetail/QuestionsCard';
import MedicalCard from './camperDetail/MedicalCard';
import DocumentsCard, { countMissingDocuments } from './camperDetail/DocumentsCard';
import { medicalApprovalToast, medicalEmailStateFrom } from './camperDetail/medicalApprovalEmail';
import SectionNav from './camperDetail/SectionNav';
import ReadinessCard from './camperDetail/ReadinessCard';
import { BalanceCard, ChargesCard, PaymentNotesCard, PaymentsList, money } from './camperDetail/PaymentPanel';
import { ShowEmptyFieldsContext } from './camperDetail/Card';
import GroupCard from './camperDetail/GroupCard';
import UsalCard from './camperDetail/UsalCard';
import InsuranceCard from './camperDetail/InsuranceCard';
import AdditionalExperienceCard from './camperDetail/AdditionalExperienceCard';
import ProductsCard from './camperDetail/ProductsCard';
import { CardRow } from './camperDetail/Card';
import ActionButton from './camperDetail/ActionButton';
import AddNoteModal from './BookingModals/AddNoteModal';
import HeaderButton from './camperDetail/HeaderButton';
import { buildSupportMailto, getSupportEmail } from './camperDetail/supportMailto';
import { BadgeCheck, FilePlus, FileText, HelpCircle, History, LifeBuoy, MessageSquare, Package, ShieldCheck, Sparkles, SquarePen, Stethoscope, User, Users } from 'lucide-react';
import { bookingUserChatAction } from '../../store/chat';
import _ from 'lodash';
import '../counselor/staffApplication/staffApplication.generated.css';
import './camperDetail/camperDetail.css';

const accountTypes = [{label: "Checking", value: 'checking'}, {label: "Savings", value: 'savings'}, {label: "business Checking", value: 'businessChecking'}]
const programRefundScopeOptions = [{label: "Full Transaction Amount", value: 'full'}, {label: "Program Amount Only", value: 'programOnly'}]
const productRefundModeOptions = [{label: "Split Across All Installments", value: 'collective'}]
const ENABLE_SPECIFIC_INSTALLMENT_PRODUCT_REFUND = false
const showProductPayHistory = (product) => {
    let isPayLater = true
    if(product?.payment?.method === 'Pay Later'){
        const paymentsLength = product.paymentArr.length
        if(paymentsLength === 0 ){
            isPayLater = false
        }else if(product.paymentArr[paymentsLength -1].status === 'failed'){
            isPayLater = false
        }
    }
    return isPayLater

}
const setting = {
    dots: true,
    infinite: false,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1
};
const isDisabled = (disabled, activeId, id ) => {
    return disabled && (activeId === id) 
}
const CamperDetail = props => {
    let history = useHistory();
    let { bookingId, programId, camperId } = props.match.params;
    const [loader, setLoader] = useState(true);
    const [refundableLoader, setRefundableLoader] = useState(false);
    const [allData, setAllData] = useState('');
    const [refundInfo, setRefundInfo] = useState(null);
    const isOldBooking = refundInfo ? !!refundInfo.isOldBooking : true;
    const [payments, setPayments] = useState([])
    const [additionalExperience, setAdditionalExperience] = useState([]);
    const [confimCancelBookingModal, setConfimCancelBookingModal] = useState(false);
    const [newRefundAmount, setNewRefundAmount] = useState(0);
    const [newRefundAmountErr, setNewRefundAmountErr] = useState('');
    const [amountUpdateModal, setAmountUpdateModal] = useState(false);
    const [remainingAmount, setRemainingAmount] = useState(0);
    const [remainingAmountErr, setRemainingAmountErr] = useState('');
    const [remainingAmountLoader, setRemainingAmountLoader] = useState(false);
    const [emiId, setEmiId] = useState('');
    const [activeQuestions, setActiveQues] = useState([]);
    const [answerModal, setAnswerModal] = useState(false);
    const [paymentInfoModal, setPaymentInfoModal] = useState(false);

    const [paymentModal, setPaymentModal] = useState(false);
    const [activePaymentObject, setActivePaymentObject] = useState({});
    const [activePaymentObject2, setActivePaymentObject2] = useState({});
    const enablePayNowTimerRef = useRef(null);

    const [amount, setAmount] = useState(0);
    const [emiObj, setEmiObj] = useState('');
    const [userId, setUserId] = useState('');
    const [userEmail, setUserEmail] = useState('');


    const [creditCardRate, setCreditCardRate] = useState({});
    const [achTransferRate, setAchTransferRate] = useState({});
    const [byCheque, setByCheque] = useState({});
    const [splitPaymentRate, setSplitPaymentRate] = useState({});

    const [paymentMethod, setPaymentMethod] = useState(0);
    const [paymentMethodErr, setPaymentMethodErr] = useState('');
    const [isNewCard, setIsNewCard] = useState(false);
    const [cardList, setCardList] = useState([]);


    const [btnLoader, setBtnLoader] = useState(false);
    const [errorMsg, setErrorMsg] = useState('');
    const [activeForm, setActiveForm]       = useState({});



    const [customerProfileId, setCustomerProfileId] = useState([]);
    const [customerPaymentProfileId, setCustomerPaymentProfileId] = useState('');
    const [customerPaymentProfileIdErr, setCustomerPaymentProfileIdErr] = useState('');
    const [customerPaymentProfileIdError, setCustomerPaymentProfileIdError] = useState('');

    const [resErr, setResErr] = useState('');

    const [bankAccountType, setBankAccountType] = useState('');
    const [bankAccountNum, setBankAccountNum] = useState('');
    const [routingNumber, setRoutingNumber] = useState('');
    const [nameOnAccount, setNameOnAccount] = useState('');
    const [bankAccountTypeErr, setBankAccountTypeErr] = useState('');
    const [bankAccountNumErr, setBankAccountNumErr] = useState('');
    const [routingNumberErr, setRoutingNumberErr] = useState('');
    const [nameOnAccountErr, setNameOnAccountErr] = useState('');



    const [campRelatedProductsModal, setCampRelatedProductsModal] = useState(false);
    const [campRelatedProducts, setCampRelatedProducts] = useState([]);
    const [campRelatedProductCount, setCampRelatedProductCount] = useState(0);
    const [productCheckoutModal, setProductCheckoutModal] = useState(false);
    const [passData, setPassData] = useState({});
    const [passDataArr, setPassDataArr] = useState([]);
    const [userProductList, setUserProductList] = useState([]);
    const [refundProductModal, setRefundProductModal] = useState(false);
    const [confirmCancelProductModal, setConfirmCancelProductModal] = useState(false);
    const [activeProductData, setActiveProductData] = useState('');
    const [productRefundAmount, setProductRefundAmount] = useState(0);
    const [productRefundAmountFixed, setProductRefundAmountFixed] = useState(0);
    const [productRefundAmountErr, setProductRefundAmountErr] = useState('');
    const [productRefundMode, setProductRefundMode] = useState(productRefundModeOptions[0]);
    const [selectedProductRefundTransaction, setSelectedProductRefundTransaction] = useState({});
    const [note, setNote] = useState('');
    const [noteErr, setNoteErr] = useState('');
    const [medicalDocumentStatus, setMedicalDocumentStatus] = useState(0);
    // Medical approval email: pending send time (countdown), sent time, no parent email.
    const [medicalEmail, setMedicalEmail] = useState(medicalEmailStateFrom());
    const [primaryCardId,setPrimaryCardId] = useState('');
    const [isDeletePopup,setIsDeletePopup] = useState(false);
    const [deleteCardToken,setDeleteCardToken] = useState('');
    const [addPrimary, setAddPrimary] = useState(false);
    const [isSwitchPrimaryCard,setIsSwitchPrimaryCard] = useState(false);
    const [holdPrimaryId, setHoldPrimaryId] = useState('');
    const [updateEMIDateModal, setUpdateEMIDateModal] = useState(false);
    const [activeEMI, setActiveEMI] = useState('');
    const [selectEmiDate, setSelectEmiDate] = useState('');
    const [addons, setAddons] = useState([]);
    const [isViewProducts, setIsViewProducts] = useState(false)
    const [activeProduct, setActiveProduct] = useState('')
    const [showInsurance, setShowInsurance] = useState([])

    const [isViewAddProducts, setIsViewAddProducts] = useState(false)
    const [activeAddProduct, setActiveAddProduct] = useState('')
    const [selectedColor, setSelectedColor] = useState('');
    const [selectedSize, setSelectedSize] = useState('');
    const [selectedColorErr, setSelectedColorErr] = useState('');
    const [selectedSizeErr, setSelectedSizeErr] = useState('');
    const [currentCount, setCurrentCount] = useState(1);
    const [existingWarning, setExistingWarning] = useState('')
    const [activeProductIndex, setActiveProductIndex] = useState(-1);
    const [activeCartId, setActiveCartId] = useState('');
    const [loading, setLoading] = useState(false);
    const [productCancellationType, setProductCancellationType] = useState(cancellationOptions[0]);
    const [cancellationType, setCancellationType] = useState(camperCancellationOptions[0]);
    const [paymentList, setPaymentList] = useState([]);
    const [selectedRefundTransaction, setSelectedRefundTransaction ] = useState({});
    const [selectedTransaction, setSelectedTransaction] = useState({});
    const [programRefundAmount, setProgramRefundAmount] = useState(0);
    const [programRefundScope, setProgramRefundScope] = useState(programRefundScopeOptions[0]);
    const [CancelRefundActionError, setCancelRefundActionError] = useState('')
    const [insuranceModal, setInsuranceModal] = useState(false);
    const [programDetails, setProgramDetails] = useState({})
    // Backend now keeps userProfile.timezone correct for super directors too (same
    // field/mechanism as real directors), so it's the primary source; programTimezone
    // is only a fallback for the brief window before programDetails has loaded.
    const userTimeZone = props?.timezone || programDetails?.programTimezone || 'UTC'
    const [programPriceText, setProgramPriceText] = useState({label:"Program Price", value: 0})
    const [addedinsurance, setAddedInsurance] = useState([])
    const [modalState, dispatch] = useReducer(ChargeAmountReducer, initialChargeAmountModalState);
    const [chargeModal, setChargeModal] = useState(false)

    const [showPaymentModal, setShowPaymentModal] = useState(false);
    const [isPayBtnDisabled, setIsPayBtnDisabled] = useState(false);
    const [isCommuter, setIsCommuter] = useState(false);
    const [isCommuterModal, setIsCommuterModal] = useState(false);
    const [isCommuterHistory, setIsCommuterHistory] = useState([]);
    const [additionalExpAudit, setAdditionalExpAudit] = useState([]);
    const [isCommuterHistoryModal, setIsCommuterHistoryModal] = useState(false);
    const [isAdditionalExpAuditModal, setIsAdditionalExpAuditModal] = useState(false);
    const [isAuditTrailModal, setIsAuditTrailModal] = useState(false);
    const [isAddNoteModal, setIsAddNoteModal] = useState(false);
    // Sidebar "Show empty fields". Off by default; remembered per browser (a view preference only).
    const [showEmptyFields, setShowEmptyFields] = useState(() => {
        try { return localStorage.getItem('bookingDetail.showEmptyFields') === '1'; } catch (e) { return false; }
    });
    const toggleShowEmptyFields = () => {
        const next = !showEmptyFields;
        setShowEmptyFields(next);
        try { localStorage.setItem('bookingDetail.showEmptyFields', next ? '1' : '0'); } catch (e) { /* storage blocked */ }
    };
    const [staffPermissions, setStaffPermissions] = useState({});

    // Staff (UserType 4) message users only with the messageCamper permission, the same rule and
    // lookup the booking list's camper cards use (BookingDetail.js).
    useEffect(() => {
        if (props.userProfile?.UserType === 4) {
            counselordetail(`/?counselorId=${props.userProfile._id}`).then(res => {
                if (res?.data?.statusCode === 1) {
                    setStaffPermissions(res.data.responseData.result.permissions || {});
                }
            });
        }
    }, [props.userProfile?.UserType, props.userProfile?._id]);
    const canMessageUser = props.userProfile?.UserType !== 4 || !!staffPermissions.messageCamper;

    // Opens this user's conversation in the inbox (ChatView consumes bookingUserChat).
    const handleMessageUser = () => {
        props.bookingUserChatAction({
            _id: allData.userId,
            name: allData?.campers?.primaryName,
            type: 1,
        });
        history.push('/inbox');
    };
    const [addExpModal, setaddExpModal] = useState(false);
    const [addExpAction, setaddExpAction] = useState(false);
    const [activeAddExp, setActiveAddExp] = useState({});
    const [emiAction, setEmiAction] = useState(false);
    const [deleteEmi, setDeleteEmi] = useState(false);
    const [emis, setEmis] = useState([]);
    const [emiDateMap, setEmiDateMap] = useState(new Map());
    const [showDeletedCards, setShowDeletedCards] = useState(false)

    const handleChargeAmountReason = (newReason) => {
        if (isOnlySpaces(newReason)) {
            handleReasonError('Please Enter a valid reason.')
        } else {
            const _reason = trimSpace(newReason)
            dispatch({ type: 'SET_REASON', payload: _reason });
            handleReasonError('')
        }
    };
    const handleReasonError = (error) => {
        dispatch({ type: 'SET_REASON_ERROR', payload: error });
    };
    const handleChargeAmountChange = (amount) => {
        dispatch({ type: 'SET_AMOUNT', payload: amount });
    }
    const handleCamperChange = (camper) => {
        dispatch({ type: 'SET_CAMPER_CHANGE', payload: camper });
    }
    const handleMetaDataChange = (b_id, b_no, p_id) => {
        dispatch({ type: 'SET_META_DATA', payload: { b_id, b_no, p_id } });
    }
    const handleCloseChargeModal = (type=1) => {
        dispatch({ type: 'RESET', payload: initialChargeAmountModalState })
        setChargeModal(false)
        setCancellationType(cancellationOptions[0]);
        if(type===1){
            getCamperBookingDetail()
            getRefundInfo()
        }
    }
    const handleBankAccountNumberChange = (e) => {
        setBankAccountNum(e.target.value);
        setBankAccountNumErr('');
   }
    useEffect(() => {
        let query = `?programId=${programId}`
        getProgramDetails(query).then((res) => {
            if (res.data.statusCode) {
                const programData = res.data.responseData.result;
                setProgramDetails(programData)
            }
        })
    }, []);

    // Prev / Next (A1). Runs once per booking: moving to another one remounts the page (see
    // CamperDetailByBooking), so this reloads with the new ids. A failure just hides the control.
    const [neighbors, setNeighbors] = useState(null);
    useEffect(() => {
        programBookingNeighborsService(`?programId=${programId}&bookingId=${bookingId}&camperId=${camperId}`)
            .then(res => { if (res?.data?.statusCode) setNeighbors(res.data.responseData.result); })
            .catch(() => {});
    }, [programId, bookingId, camperId]);

    // "Send reminder" on Documents & Waivers (A4). The API answers "nothing missing" and "already
    // sent today" as a normal response with sent: false, so the toast shows its message either way;
    // only a real send refetches, to put the new entry under Activity.
    const [sendingReminder, setSendingReminder] = useState(false);
    // Group Assignment "Approved" switch (client request): counts the readiness group check as done
    // without an organizer assignment. Optimistic, reverted if the save fails; a real save refetches
    // so the new Activity entry shows.
    const [groupApproved, setGroupApproved] = useState(false);
    const handleGroupApprovalToggle = () => {
        const next = !groupApproved;
        setGroupApproved(next);
        groupApprovalService({ bookingId, programId, camperId, groupApproved: next })
            .then(res => {
                if (res?.data?.statusCode) {
                    notificationMsg(1, res.data.responseData?.message);
                    getCamperBookingDetail();
                } else {
                    setGroupApproved(!next);
                    notificationMsg(0, res?.data?.error?.errors?.message);
                }
            })
            .catch(() => { setGroupApproved(!next); notificationMsg(0); });
    };
    const handleSendDocumentReminder = () => {
        setSendingReminder(true);
        sendDocumentReminderService({ bookingId, programId, camperId })
            .then(res => {
                notificationMsg(res?.data?.statusCode, res?.data?.responseData?.message);
                if (res?.data?.statusCode && res.data.responseData?.sent) getCamperBookingDetail();
            })
            .catch(() => notificationMsg(0))
            .finally(() => setSendingReminder(false));
    };

    // replace, not push: Back (history.goBack) should still return to the screen that opened the
    // page, not step back through every registration visited with Prev / Next.
    const goToRegistration = ({ bookingId: nextBookingId, camperId: nextCamperId }) =>
        history.replace(`/bookings/${nextBookingId}/${nextCamperId}/${programId}`);

    useEffect(() => {
        if(Object.keys(programDetails).length && allData?.bookingDate && allData?.campers?.purchaseType == null){
            const priceSelectionDates ={
                dateEarlyRegisterOpen: programDetails?.dateEarlyRegisterOpen ,
                dateEarlyRegisterClosed: programDetails?.dateEarlyRegisterClosed ,
                registerOpenDate: programDetails?.registerOpenDate ,
                registerCloseDate: programDetails?.registerCloseDate ,
                dateLateRegisterOpen: programDetails?.dateLateRegisterOpen ,
                dateLateRegisterClosed: programDetails?.dateLateRegisterClosed ,
            }
            let selectionPrice = {
                lateRegistrationFee:programDetails.lateRegistrationFee,
                earlyBirdPrice: programDetails.earlyBirdPrice,
                registrationFee: programDetails.registrationFee,
            }
            if( allData?.campers?.byDates && allData?.campers?.byDates === 1 ){
                selectionPrice.lateRegistrationFee = allData?.campers?.campRegistrationFee ?? 0;
                selectionPrice.earlyBirdPrice = allData?.campers?.campRegistrationFee ?? 0;
                selectionPrice.registrationFee = allData?.campers?.campRegistrationFee ?? 0;
            }
            const priceText = getPriceCategory(priceSelectionDates, allData?.bookingDate, selectionPrice);
            const fee = allData?.campers?.campRegistrationFee ?? 0;
            // Director checkout (calcPriceCamperWise) folds registerNonRefundFee into campRegistrationFee on
            // tiered programs; date-block programs and parent checkout store the bare price. The fee has its
            // own "Non-refundable Fee" line below, so it is taken out here rather than counted twice.
            // refundableFee is not usable here: coupons, add-ons, discounts and refunds all change it.
            const includesNonRefundFee = allData?.isDirectorBooking === true && allData?.campers?.byDates !== 1;
            priceText.value = includesNonRefundFee ? fee - (allData?.campers?.registerNonRefundFee ?? 0) : fee;
            setProgramPriceText(priceText)
        }
    }, [programDetails, allData])


    const handleShowEditModal = item => {
        setAnswerModal(true);
        setActiveQues(item);//
    }


    const getFullTransactionRemaining = transaction => {
        let remainingAmount = transaction?.amount || 0;
        if(transaction?.refunds?.length > 0){
            for(let i =0; i < transaction?.refunds?.length; i++  ){
                remainingAmount -= transaction?.refunds[i]?.amount;
            }
        }
        return remainingAmount;
    }

    const getAdditionalChargeEntry = transactionId => {
        return refundInfo?.additionalCharges?.find(a => a.transactionId === transactionId) || null;
    }

    const isAdditionalChargeTransaction = !isOldBooking && !!getAdditionalChargeEntry(selectedRefundTransaction?.value);

    const handleRefundTransaction = (e) => {
        setSelectedRefundTransaction(e);
        const _selectedTransaction = paymentList.find(tr => tr.transaction_id === e.value);

        setProgramRefundScope(programRefundScopeOptions[0]);
        setNewRefundAmountErr('');
        setSelectedTransaction(_selectedTransaction);

        if(isOldBooking){
            const remainingAmount = getFullTransactionRemaining(_selectedTransaction);
            setProgramRefundAmount(remainingAmount)
            setNewRefundAmount(remainingAmount)
        }else{
            const entry = getAdditionalChargeEntry(e.value) || getRefundInfoTransactions().find(t => t.transactionId === e.value);
            const fullAmount = entry?.total?.feeInclusive || 0;
            setProgramRefundAmount(fullAmount);
            setNewRefundAmount(fullAmount);
        }
    }

    const handleProgramRefundScopeChange = e => {
        setProgramRefundScope(e);
        setNewRefundAmountErr('');
        const entry = getRefundInfoTransactions().find(t => t.transactionId === selectedRefundTransaction.value);
        // camperCancelRefundAction refunds exactly the amount it's given (unlike the product
        // refund action, which adds the fee share itself), so we cap at and send the
        // fee-inclusive figure here, not the base amount.
        if(e.value === 'programOnly'){
            const feeInclusive = entry?.program?.feeInclusive || 0;
            setProgramRefundAmount(feeInclusive);
            setNewRefundAmount(feeInclusive);
        }else{
            const fullAmount = entry?.total?.feeInclusive || 0;
            setProgramRefundAmount(fullAmount);
            setNewRefundAmount(fullAmount);
        }
    }
    const handleSubmitAns = () => {
        let validate = true
        //Add validation before submit 
        // Task1: fetch all queestions and map them for questionId/AnswerId(_id) and answers
        let _questions = [...activeQuestions];
        if(activeQuestions.length){
            _questions = _questions.map(item => {
                const _newItem = {
                    ...item,
                    answerErr: (item?.isRequred === 1 ) ? (item.answer || item?.isSkipped) ? '' : 'This field is required' : ''  
                }
                const {isSkipped, ...newItem} = _newItem
                 return newItem; 
            })
            let has_questions_err = _questions.filter(item => item.answerErr);

            if(has_questions_err.length){
                let element = document.getElementById(has_questions_err[0]._id);
                if (element) {
                    element.scrollIntoView({ behavior: "smooth" });
                }
                setActiveQues(_questions);
                validate = false
            }
        }
        if(validate){
            const _allAnswers = activeQuestions.map(item => ({
                                answerid:item?._id, 
                                questionId: item.questionId,
                                answer: Array.isArray(item.answer) ? item.answer.join(", ") : item.answer
                                }))
    
            const parmas = {
                programId, 
                camperId,
                bookingId,
                answers: [..._allAnswers]
    
            }
            editAllAnsByDirService(parmas).then((res) => {
                // setAnswerModal(false)
                notificationMsg(res.data.statusCode, res.data.responseData.message);

               
                getCamperBookingDetail();
         }).catch((error) => console.log(error)).finally(() =>setAnswerModal(false) )
        }
    }


    const getCamperBookingDetail = () => {
        let query = `?bookingId=${bookingId}&programId=${programId}&camperId=${camperId}`;
        
        bookingCamperDetailService(query).then(res => {

            setLoader(false);
            if(res?.data?.statusCode){
                const _allData = res.data.responseData.result;
                setAllData(_allData);
                const _emis = _allData?.isEmi?.allEmiRemains || []
                if(_emis.length > 0){
                    const _mappedEmis = sortByTimestamp(_emis,"asc",'emiDate')
                    setEmis(_mappedEmis)
                    const emiMap = new Map([])
                    _mappedEmis.forEach((_e, i )=> {
                        emiMap.set(_e._id, _e.emiDate)
                    })
                    setEmiDateMap(emiMap)
                }
                setIsCommuter(_allData.campers?.isCommuter );
                setGroupApproved(_allData.campers?.groupApproved === true);
                setIsCommuterHistory(_allData.campers?.isCommuterHistory ?? [])
                getPayments(_allData);
                const campRegistrationFee = _allData.campers?.campRegistrationFee;
                const purchaseType = _allData.campers?.purchaseType;
                // purchaseType 0 is early bird, so test for presence rather than truthiness.
                if( campRegistrationFee && purchaseType != null ){
                    const price = setProgramPrice(campRegistrationFee, purchaseType);
                    setProgramPriceText(price);
                }
                let _addedinsurance = []
                const _allCamperData = _allData.campers;
                if(_allCamperData?.insuranceData?.length > 0){
                    _addedinsurance = _allCamperData?.insuranceData?.filter(ins => ins.insuranceStatus === 1)
                    if(_addedinsurance?.length > 0){
                        _addedinsurance =  _addedinsurance.map(ins => {
                            return ins.product.name
                        })
                    }
                }
                setAddedInsurance(_addedinsurance); 
                setUserId(_allData.userId);
                setUserEmail(_allData.campers.email);
                setMedicalDocumentStatus(_allData?.campers.medicalDocumentStatus)
                setMedicalEmail(medicalEmailStateFrom(_allData));
            }
        })

        let params = {
            bookingId,
            programId,
            camperId
        }
        getAdditionalExperienceService(params).then(res => {
            if(res?.data?.statusCode){
                const data = res.data.responseData.result;
                setAdditionalExperience(data.additionalExperience);
                setAdditionalExpAudit(data?.additionalExperienceAudit ?? [])
            }
        })
    }



    useEffect(() => {
        getCamperBookingDetail();

        return () => {
            props.saveCabinIdAction('');
        }
    }, [])

    const getPayments = (allData) => {
        if(allData?.paymentArr){
            setPayments(allData.paymentArr.filter(py => {
                const metadata = py?.metadata;
                if (!metadata) return true;
            
                if (metadata.type === 'additionalCharge') {
                    return metadata.camperId === camperId;
                }

                return true;
            }))
        }
    }

    


    const removeStr = s => {
        if(s.includes(',')){
            return s.replace('[', '').replace(']', '').replace(/["]/g, "").replace(/[,]/g, ", ")
        }else{
            return s.replace(/["]/g, "")
        } 
    }



    const handleRefund = () => {

        if(newRefundAmount === 0){
            setNewRefundAmountErr('Refund amount not valid')
        }else if(newRefundAmount > allData.campers.refundableFee){
            setNewRefundAmountErr('Refund amount not bigger then program cost')
        }else {
            let params = {
                bookingId,
                programs: [
                    {
                        programId,
                        campers: [
                            {
                                programCost: newRefundAmount,
                                camperId
                            }
                        ]
                    }
                ]
            }
    
            setRefundableLoader(true);
    
            refundBookingByCampers(params).then(res => {
                setRefundableLoader(false);
                if(res?.data?.statusCode){
                    history.push(`/bookings/${programId}`)
                    notificationMsg(1,'Booking canceled', 'Booking',);
                }
            })
        }

        


    }


    const handleCancelRefundBookingAction = () => {    
            setBtnLoader(true)
            let action = 'canceled'
            if(cancellationType.value ===2 && (allData?.campers?.status === 2 || allData?.campers?.status === 4) ){
                setCancelRefundActionError("Booking is already canceled, please try other options.")
                setBtnLoader(false)
                return
            }
            let params = {
                bookingId,
                programId,
                programCost: allData.campers.refundableFee,
                camperId, 
                actionType: cancellationType.value
            }
            
            if(cancellationType.value === 3 || cancellationType.value === 4){
                cancellationType.value === 3  ? action='Refunded' : action='Canceled and Refunded';
                if(newRefundAmount === 0){
                    setNewRefundAmountErr('Refund amount must be grater than zero.')
                    setBtnLoader(false)
                    return;
                }else if(newRefundAmount > programRefundAmount){
                    setNewRefundAmountErr('Refund amount must not be greater than the transaction amount.')
                    setBtnLoader(false)
                    return
                }else{
                    params.programCost = newRefundAmount;
                    params['transaction_id'] = selectedRefundTransaction.value;
                }
            }
    
            camperCancelRefundAction(params).then(res => {
                if(res.data.statusCode){
                    notificationMsg(1,  `Booking ${action}.`, 'Booking')
                }else{
                    notificationMsg(1, 'Something went wrong. Please try Again.');  
                }
                handleCloseRefundCancelCamper()
                getCamperBookingDetail();
                getRefundInfo();
            })

    }

    const handleCloseRefundCancelCamper = () => {
        setCancellationType(cancellationOptions[0]);
        setConfimCancelBookingModal(false);
        setBtnLoader(false)
        setSelectedRefundTransaction({})
        setSelectedTransaction({})
        setNewRefundAmount(0)
        setProgramRefundAmount(0)
        setProgramRefundScope(programRefundScopeOptions[0])
        setNewRefundAmountErr('')
        setCancelRefundActionError('')
    }


    const handleUpdateAmount = () => {

        if(note === '' || note === undefined || note === null){
            setNoteErr('Please add a note');
        }else{

            if(remainingAmount || remainingAmount === 0){

                let params = '';
    
                
    
                if(emiId._id){
                    params = {
                        bookingId,
                        remainingAmount: (emiId.remainingAmount || 0) - (emiId.emiAmount - remainingAmount),
                        emiId: emiId._id,
                        emiAmount:  remainingAmount,
                        notes: {
                            notes: note,
                            diff: emiId.emiAmount < remainingAmount ? true : false,
                            difference: Math.abs(remainingAmount - emiId.emiAmount)
                        }
                    }
                }else{
                    params = {
                        bookingId,
                        remainingAmount: remainingAmount,
                        notes: {
                            notes: note,
                            diff: activePaymentObject2.remainingAmount < remainingAmount ? true : false,
                            difference: Math.abs(remainingAmount - activePaymentObject2.remainingAmount )
                        }
                    }
                }
    
    
    
                setRemainingAmountLoader(true);
                updateRemainingAmountService(params).then(res => {
                    setRemainingAmountLoader(false);
                    setAmountUpdateModal(false);
                    setEmiId('');
                    setNote('');
                    if(res?.data?.statusCode){
                        notificationMsg(1,  'Amount updated successfully','Amount');

                        getCamperBookingDetail();
                        getRefundInfo();
                    }
                })
            }

        }


        

        
    }


    const handleResendBookingEmail = () => {
        let params = { bookingId }

        resendBookingEmailService(params).then(res => {
            if(res.data.statusCode){
                notification.open({
                    message: 'Booking',
                    description: `Email sent successfully`,
                });
            }
        })
    }


    const checkHasCommuter = list => {
        if(list.length){
            let _commuterPrice = 0;
            for (let i = 0; i <= list.length; i++) {
                if(list[i]?.commuterPrice){
                    _commuterPrice = _commuterPrice + list[i].commuterPrice
                }
            }
            if(_commuterPrice > 0){
                return true;
            }else{
                return false; 
            }
        }else{
            return false; 
        }
    }


    const enablePayNow = () => {
        setIsPayBtnDisabled(false)
        setActivePaymentObject({});
        setActivePaymentObject2({});
    }
    const handleCloseModal = () => {
        setPaymentModal(false);
        setErrorMsg('');
        enablePayNowTimerRef.current = setTimeout(enablePayNow, 30000)
        setCampRelatedProductsModal(false);
        setBankAccountType('')
        setBankAccountNum('')
        setRoutingNumber('')
        setNameOnAccount('')

        let _campRelatedProducts = campRelatedProducts.map(j => ({
            ...j,
            selectColor: '',
            selectSize: '',
            selectColorErr: '',
            selectSizeErr: '',
            isSelected: false

        }));
        setCampRelatedProducts(_campRelatedProducts);
        getCamperBookingDetail();
        getRefundInfo();
    }


    const getTaxs = () => {
        getCampDetailService(`?campCode=${props.campCode}`).then(res => {
            if(res?.data?.statusCode){
              let _data = res.data.responseData.result;
              setCreditCardRate(_data.creditCardRate || {});
              setAchTransferRate(_data.achTransferRate || {});
              setByCheque(_data.byCheque || {});
              setSplitPaymentRate(_data.splitPaymentRate || {});
              setShowInsurance(_data.showInsurance);
            }
        })
    }

    useEffect(() => {
        if(props.campCode && userId){
            getTaxs();
            getCards();
        }

    }, [props.campCode, userId, paymentModal, showDeletedCards])





    const handleValidate = () => {
        let validate = true;

        if(amount > 0){
            if(paymentMethod === 0){
                validate = false;
                setPaymentMethodErr('Please select payment method');
            }
    
            if(paymentMethod === 1){
                if(customerPaymentProfileId === '' || customerPaymentProfileId === 'undefined' || customerPaymentProfileId === null){
                    validate = false;
                    setCustomerPaymentProfileIdError('Please select card')
    
                }
            }


            if(paymentMethod === 3) {

                if(bankAccountType === '' || bankAccountType === 'undefined' || bankAccountType === null){
                    validate = false;
                    setBankAccountTypeErr('Account type is required')
                }

                if(bankAccountNum === '' || bankAccountNum === 'undefined' || bankAccountNum === null){
                    validate = false;
                    setBankAccountNumErr('Account number is required')
                }

                if(routingNumber === '' || routingNumber === 'undefined' || routingNumber === null){
                    validate = false;
                    setRoutingNumberErr('Routing number is required')
                }

                if(nameOnAccount === '' || nameOnAccount === 'undefined' || nameOnAccount === null){
                    validate = false;
                    setNameOnAccountErr('Account holder name is required')
                }

            }
        }

       

        return validate;
    }



 


    const getCards = () => {
        setLoader(true)
        setCardList([]);
        setHoldPrimaryId('');
        setPrimaryCardId('');
        let query = `?userId=${userId}&isWeb=1&campCode=${props.campCode}&includeDeleted=${showDeletedCards}`
        getCustomerCardsService2(query).then(res => {
            if (res.data.statusCode) {
                if(res.data.responseData.result.length){
                    const cardList = res.data.responseData.result
                    setCardList(cardList);
                    setCustomerProfileId(cardList[0].card.signature);
                    let primaryCard = ''
                   for(let i =0; i < cardList.length ; i++){
                        if(cardList[i]?.card?.metadata?.primary){
                            primaryCard= cardList[i].card.token;
                        }else{
                            continue;
                        }
                    }
                    if(cardList.length){
                        const _selectedCard = cardList[0]?.card?.token ?? "";
                        setCustomerPaymentProfileId(_selectedCard)
                    }
                    setPrimaryCardId(primaryCard)
                    setLoader(false)
                }else{
                    setLoader(false)
                    setIsNewCard(true);
                }
            } else {
                setLoader(false)
                setCardList([]);
            }
        }).catch((e) => {
            console.log(e)
        }).finally(() => {
            setLoader(false)
        })
    }






    const handleCreateBooking = () => {

        if (handleValidate()) {
            setBtnLoader(true);
            let params = {};

            

            if (paymentMethod === 1) {
                params = {
                    bookingId,
                    authPayment: {
                        paymentType: paymentMethod,
                        customerProfileId,
                        token: customerPaymentProfileId
                    },
                    payment: {
                        method: "Credit Card",
                        amount: getWithTaxPrice(creditCardRate, amount),
                        applicationFeeAmount : getTaxForPrice(creditCardRate, amount)
                    },
                    campCode: props.campCode
                }

                if(activePaymentObject._id){
                    params.emiId = activePaymentObject._id;
                    params.emiAmount = amount?.toFixed(2);
                    if(activePaymentObject.emiAmount === amount){
                        params.isFullPayment = true;
                    }
                }else{
                    params.remainingAmount = activePaymentObject2.remainingAmount - amount;
                }

            }


            if(paymentMethod === 3) {

                const __routing_number = AES.encrypt(routingNumber, settings.api.mySecretKey).toString();
                const __bankAccountNum = AES.encrypt(bankAccountNum, settings.api.mySecretKey).toString();

                params = {
                    isWeb: 1,
                    bookingId,
                    authPayment: {
                        account_owner_name: nameOnAccount,
                        routing_number: __routing_number,
                        account_number: __bankAccountNum,
                        account_type: bankAccountType.value,
                        account_owner_type: 'individual',
                        country: 'US',
                        currency: 'usd',
                        paymentType: 4
                    },
                    payment: {
                        method: 'Internet Banking',
                        amount: getWithTaxPrice(achTransferRate, amount),
                        applicationFeeAmount : getTaxForPrice(achTransferRate, amount)
                    },
                    campCode: props.campCode
                }

                if(activePaymentObject._id){
               

                    params.emiId = activePaymentObject._id;
                    params.emiAmount = amount?.toFixed(2);
    
                    if(activePaymentObject.emiAmount === amount){
                        params.isFullPayment = true;
                    }
                }else{
                    params.remainingAmount = activePaymentObject2.remainingAmount - amount;
                }
        
            }
            params.actionSource = 0;
            params.isEmiPayment = activePaymentObject?.isEmiPayment === 1 ? 1 : 0;

            
    
            deductPaylaterAmountService(params).then(res => {
                let { status, data } = resHandle(res);
                setBtnLoader(false);
                if(status){
                    setIsPayBtnDisabled(true)
                    handleCloseModal();
                    notification.open({
                        message: 'Payments',
                        description:
                            'Payment create successfully',
                    });
                } else {
                    setErrorMsg(res.data.error.errors.message || res.data.error.responseMessage);
                }
            })
        }  
        
    }



    const getProducts = () => {
        let query = `?&page=0&limit=100&type=2&itemType=1&programId=${programId}`;
        getProductsService(query).then(res => {
            if(res?.data?.statusCode){
                let _result = res.data.responseData.result;
                let _result2 = _result.map(i => ({
                    ...i,
                    count: 1,
                    selectedSize: '',
                    selectColor: ''
                }))
                setCampRelatedProducts(_result2);
                setCampRelatedProductCount(res.data.responseData.count);
            }
        })
    }

    useEffect(() => {
        getProducts()
    }, [])


    const handleStoreCount = (type, index) => {
        let _campRelatedProducts = [...campRelatedProducts];
        if(type === 'add'){
            _campRelatedProducts[index].count = _campRelatedProducts[index].count + 1
            
        }else{
            if(_campRelatedProducts[index].count !== 1){
                _campRelatedProducts[index].count = _campRelatedProducts[index].count - 1
            }
        }
        setCampRelatedProducts(_campRelatedProducts);
    }




    const handleRemoveToCartProduct = (item, _index) => {
        if(_index === -1){
            _index = activeProductIndex
        }
        let _campRelatedProducts = [...campRelatedProducts];
        _campRelatedProducts[_index].isSelected = false;
        _campRelatedProducts[_index].selectSize = '';
        _campRelatedProducts[_index].selectSizeErr = '';
        _campRelatedProducts[_index].selectColor = '';
        _campRelatedProducts[_index].selectColorErr = '';
        _campRelatedProducts[_index].count = 1;
        _campRelatedProducts[_index].subItems = item.subItems.map(item => ({...item,count:0 }));
        setCampRelatedProducts(_campRelatedProducts);


        let _passDataArr = [...passDataArr];

        let res = _passDataArr.filter(j => j.itemId !== item._id);
        setPassDataArr(res);
        const _cartId = _passDataArr.filter(j => j.itemId === item._id)[0]?.cartId;
        removeFromCart(`/?cartId=${_cartId}`).then(res => {
            if(res.data.statusCode){
                setActiveProductIndex(-1)
                notification.open({
                    description:
                        'Deleted successfully',
                })
            }else{
                notification.open({
                    description:
                        'Something went wrong.',
                })
            }
            handleAddCloseModal()
            
        });
    }


    const handleAddToCartProduct = (item) => {        
        let validate = true;
        let _campRelatedProducts = [...campRelatedProducts];
        const _index = _campRelatedProducts.indexOf(item)
        if(getSizes(activeAddProduct.sizes).length){
            if(selectedSize === '' || selectedSize === 'undefined' || selectedSize === null){
                setSelectedSizeErr('Please select size');
                validate = false;
            } 
        }

        if(getColors2(activeAddProduct.sizes).length){
            if(selectedColor === '' || selectedColor === 'undefined' || selectedColor === null){
                setSelectedColorErr('Please select color');
                validate = false;
            }
        }

        if(validate){
            let params = {
                itemId: item._id,
                color: selectedColor,
                sizes: selectedSize,
                count: currentCount,
                bookingId: bookingId,
                camperId: camperId,
                userId,
                programId, 
            }
            
            if(addons.length > 0){
                const _addons =  addons.filter(itm => itm.count > 0)   
                params.subItems = _addons.map(item => ({
                    count:item.count,
                    color:item.color,
                    price:item.price,
                    title:item.title,
                    itemId:item.itemId,
                    sizes:item.sizes,
                }))
                 
            }else {
                params.subItems =[];
            }

            addProductIntoCartService(params).then(res => {
                if(res.data.statusCode){
                    _campRelatedProducts[_index].isSelected = true;
                    let _passDataArr = [...passDataArr];
                    let _cartId
                    let _totalPrice
                    let _subItems
                    if(Array.isArray(res.data.responseData)){
                        _cartId =  res.data.responseData[0]._id
                        _totalPrice = item?.subItems?.length > 0 ?
                        (item.count * item.price) + res.data.responseData[0]?.items?.subItems.reduce((_total, i) =>  (i.count * i.price) + _total, 0)
                        : item.count * item.price;
                        _subItems =  [...res.data.responseData[0].items?.subItems]
                    }else{
                        _cartId = res.data.responseData._id
                        _totalPrice = item?.subItems?.length > 0 ?
                        (item.count * item.price) + (res.data.responseData.items.subItems.reduce((_total, i) =>  (i.count * i.price) + _total, 0)) 
                        : item.count * item.price;
                        _subItems =  [...res.data.responseData.items?.subItems]
                    }

                    _passDataArr.push({
                        cartId: _cartId,
                        itemId: item._id,
                        price: _totalPrice,
                        subItems:[..._subItems]
                    })
                    setPassDataArr(_passDataArr);
                 
                }else{
                    _campRelatedProducts[_index] = [...res.data.responseData[0].items?.subItems]
                    _campRelatedProducts[_index].isSelected = false;
                }
            })
            handleAddCloseModal()
        }

        setCampRelatedProducts(_campRelatedProducts);
       
    }


    const handleCheckout = () => {
            setProductCheckoutModal(true);
            handleCloseModal();
    }


    const handleBookingSubmit = () => {
        setProductCheckoutModal(false);
        getCamperBookingDetail();
        productListByBooking();
        getRefundInfo();
        notification.open({
            description: 'Booking created successfully',
        });
    }



    const productListByBooking = () => {
        let query = `?bookingId=${bookingId}&programId=${programId}&camperId=${camperId}`;

        productListByBookingSerivce(query).then(res => {
            if(res.data.statusCode){
                setUserProductList(res.data.responseData.result);
                setPassDataArr([])
                getProducts()
            }
        })
    }

    const getRefundInfo = () => {
        let query = `?bookingId=${bookingId}`;

        getRefundInfoService(query).then(res => {
            if(res.data.statusCode){
                setRefundInfo(res.data.responseData);
            }
        })
    }


    useEffect(() => {
        if(bookingId){
            productListByBooking()
            getRefundInfo()
        }
    }, [bookingId])


    const getProductFeeRatio = product => {
        const bookingAmount = product?.purchaseType !== 2 ? product?.payment?.amount : allData?.payment?.amount;
        const bookingApplicationFee = product?.purchaseType !== 2 ? product?.payment?.applicationFeeAmount : allData?.payment?.applicationFeeAmount;
        const preFeeTotal = bookingAmount - bookingApplicationFee;
        if(!bookingApplicationFee || bookingApplicationFee <= 0 || preFeeTotal <= 0){
            return 1;
        }
        return bookingAmount / preFeeTotal;
    }

    const getRefundInfoTransactions = () => {
        if(!refundInfo) return [];
        if(refundInfo.installments?.length) return refundInfo.installments;
        if(refundInfo.payment) return [refundInfo.payment];
        return [];
    }

    const getProductRefundInfoEntry = product => {
        if(!refundInfo || !product) return null;
        const list = product?.purchaseType === 2 ? refundInfo.productsPurchasedWithBooking : refundInfo.productsPurchasedSeparately;
        return list?.find(p => p.purchaseId === product?.purchaseId && p.itemId === product?.itemId) || null;
    }

    // Bundled products' costs are split evenly across installments on multi-EMI bookings, so
    // refunding one needs either a specific installment's own share or an even split across all of them.
    const hasMultipleProductInstallments = () => getRefundInfoTransactions().length > 1;

    const getProductEntryForTransaction = (transaction, product) => {
        if(!transaction || !product || !Array.isArray(transaction.productsWithBooking)) return null;
        return transaction.productsWithBooking.find(p => p.purchaseId === product?.purchaseId && p.itemId === product?.itemId) || null;
    }

    const isSpecificInstallmentProductRefund = product => !isOldBooking && product?.purchaseType === 2 && hasMultipleProductInstallments() && productRefundMode.value === 'specific';

    const getProductMaxRefundableBase = product => {
        if(isOldBooking){
            return calculateProductRefundPrice(product, getProductFeeRatio(product));
        }
        if(isSpecificInstallmentProductRefund(product)){
            const transaction = getRefundInfoTransactions().find(t => t.transactionId === selectedProductRefundTransaction.value);
            return getProductEntryForTransaction(transaction, product)?.base || 0;
        }
        return getProductRefundInfoEntry(product)?.base || 0;
    }

    const handleProductCancelRefund = item => {
        setConfirmCancelProductModal(true);
        setActiveProductData(item);
        setProductRefundMode(productRefundModeOptions[0]);
        setSelectedProductRefundTransaction({});
        setProductRefundAmountErr('');
        if(isOldBooking){
            setProductRefundAmount(calculateProductRefundPrice(item, getProductFeeRatio(item)));
        }else{
            setProductRefundAmount(getProductRefundInfoEntry(item)?.base || 0);
        }
    }

    const handleProductRefundModeChange = e => {
        setProductRefundMode(e);
        setSelectedProductRefundTransaction({});
        setProductRefundAmountErr('');
        if(e.value === 'collective'){
            setProductRefundAmount(getProductRefundInfoEntry(activeProductData)?.base || 0);
        }else{
            setProductRefundAmount(0);
        }
    }

    const handleProductRefundTransactionChange = e => {
        setSelectedProductRefundTransaction(e);
        setProductRefundAmountErr('');
        const transaction = getRefundInfoTransactions().find(t => t.transactionId === e.value);
        setProductRefundAmount(getProductEntryForTransaction(transaction, activeProductData)?.base || 0);
    }






    const getProductDisplayRefundAmount = (product, amount) => {
        const maxRefundableBase = getProductMaxRefundableBase(product);
        const enteredAmount = amount ?? maxRefundableBase;
        if(isOldBooking){
            const bookingAmount = product?.purchaseType !== 2 ? product?.payment?.amount : allData?.payment?.amount;
            const bookingApplicationFee = product?.purchaseType !== 2 ? product?.payment?.applicationFeeAmount : allData?.payment?.applicationFeeAmount;
            return calculateProductRefundWithFee(bookingAmount, bookingApplicationFee, enteredAmount);
        }
        let feeInclusive;
        if(isSpecificInstallmentProductRefund(product)){
            const transaction = getRefundInfoTransactions().find(t => t.transactionId === selectedProductRefundTransaction.value);
            feeInclusive = getProductEntryForTransaction(transaction, product)?.feeInclusive || 0;
        }else{
            feeInclusive = getProductRefundInfoEntry(product)?.feeInclusive || 0;
        }
        if(!maxRefundableBase){
            return enteredAmount;
        }
        return (enteredAmount / maxRefundableBase) * feeInclusive;
    }

    const handleProductCancelRefundAction = () => {
        setBtnLoader(true)
        // Only the refunding actions need an amount. CANCEL ONLY (2) doesn't send one at all, so
        // requiring it here blocked cancelling a product with nothing left to refund - which is now
        // a common, correct state rather than a rare one, since the max no longer overstates what
        // an already-refunded product has available.
        const isProductRefundAction = productCancellationType.value === 3 || productCancellationType.value === 4;
        if(isProductRefundAction && !productRefundAmount){
            setProductRefundAmountErr('Please enter refund amount')
            setBtnLoader(false)
            return
        }else if(isProductRefundAction && productRefundAmount > getProductMaxRefundableBase(activeProductData)){
            setProductRefundAmountErr('Refund amount must not be greater than the product amount.')
            setBtnLoader(false)
            return
        }else{
            let params = {
                bookingId,
                camperId,
                programId,
                itemId: activeProductData?.itemId,
                actionType: productCancellationType.value,
                purchaseId:activeProductData?.purchaseId
            }
            if(productCancellationType.value === 3 || productCancellationType.value === 4 ){
                params.amount = productRefundAmount
                if(!isOldBooking && activeProductData?.purchaseType === 2){
                    const transactions = getRefundInfoTransactions();
                    if(transactions.length <= 1){
                        // single transaction on the booking: always tie the refund to it
                        if(transactions[0]?.transactionId){
                            params.transaction_id = transactions[0].transactionId;
                        }
                    }else if(productRefundMode.value === 'specific' && selectedProductRefundTransaction.value){
                        params.transaction_id = selectedProductRefundTransaction.value;
                    }
                    // collective mode across multiple installments: no transaction_id, backend splits it
                }
            }
            if(activeAddProduct?.sizes){
                params.sizes = activeAddProduct.sizes
            }
            if(activeAddProduct?.color){
                params.color = activeAddProduct.sizes
            }
            setConfimCancelBookingModal(false);
    
            cancelRefundAction(params).then(res => {
                if(res.data.statusCode){
                    const resultAmount = res.data.responseData?.amount;
                    notification.open({
                        message: `PRODUCT ${cancellationOptions[productCancellationType?.value -2].label} SUCCESSFUL`,
                        description: resultAmount ? `${res.data.responseData?.message}. Refunded Amount: $${resultAmount.toFixed(2)}` : res.data.responseData?.message,
                    });
                }else{
                    notification.open({
                        description: 'Something went wrong. Please try Again.',
                    });  
                }
                setConfirmCancelProductModal(false);
                setProductCancellationType(cancellationOptions[0]);
                productListByBooking();
                getRefundInfo();
                setBtnLoader(false)
            })
        }
       
    }

    // Countdown hit zero: give the job a few seconds to send and log it, then show "sent".
    const handleMedicalEmailElapsed = () => {
        setTimeout(getCamperBookingDetail, 5000);
    }

    const handleUserStatusChange = () => {
            // bookingId/programId: approving from this booking emails the parent after a delay
            // (switching it back off in that window cancels the email).
            let params = {participantId: camperId, medicalDocumentStatus: medicalDocumentStatus === 1 ? 2 : 1, bookingId, programId}
            setMedicalDocumentStatus(medicalDocumentStatus === 1 ? 2 : 1);
            if (medicalDocumentStatus === 1) {
                // Switching off: drop the countdown straight away.
                setMedicalEmail(prev => ({ ...prev, sendAt: null }));
            }
            medicalDocumentStatusChangeSerivce(params).then(res => {
                if(res.data.statusCode){
                    const data = res.data.responseData;
                    const emailToast = medicalApprovalToast(data);
                    if(emailToast){
                        notification.open({
                            description: emailToast,
                        });
                    }else if(data.result.medicalDocumentStatus === 1){
                        notification.open({
                            description: 'Medical clearance approved.',
                        });
                    }else if(data.result.medicalDocumentStatus === 2){
                        notification.open({
                            description: 'Medical clearance approval removed.',
                        });
                    }
                    if(params.medicalDocumentStatus === 1){
                        setMedicalEmail(medicalEmailStateFrom(data));
                    }
                    // Picks up the new Activity entry.
                    getCamperBookingDetail();
                }
            }).catch (error => {
                notification.open({
                    description: 'something went wrong',
                }); 
                console.error('Error during service worker registration:', error);
            })
    }

    const getNextPaymentDate = data => {
        let _filterd = data?.isEmi?.allEmiRemains?.filter(r_emis => r_emis.status === 2);

        if(_filterd.length){
            return moment(_filterd[0].emiDate).format('MMM DD, YYYY')
        }else {
            return '----'
        }

        
    }


    // Documents card: a signed form opens read-only, an unsigned one with "I Agree" (updateBookingKey).
    // The Waiver Disclaimer is the parent side's PDF (ViewBooking); it's booking-wide, so agreeing
    // here marks it for every participant on the booking.
    const BOOKING_FORM_PDFS = {
        keyDeposit: require('../../assets/pdf/key-deposit.pdf'),
        concussion: require('../../assets/pdf/concussion-protocol.pdf'),
        isDisclaimer: require('../../assets/pdf/Waiver-disc.pdf'),
    };
    const openBookingForm = (type, signed) => {
        const url = BOOKING_FORM_PDFS[type];
        setActiveForm({ viewType: signed, camperId, type, url });
    }

    const updateBookingKey = () => {
        let params = { bookingId, programId }

        if(activeForm.type === 'keyDeposit'){
            params.keyDeposit = true;
            params.camperId = activeForm.camperId;
        }else if(activeForm.type === 'isDisclaimer'){
            params.isDisclaimer = true;
        }else{
            params.concussion = true;
            params.camperId = activeForm.camperId;
        }

        setActiveForm({})
        updateBookingKeyService(params).then(res => {
            if(res?.data?.statusCode){
                getCamperBookingDetail();
            }
        })
    }



    const handleFileChange = (e, camperId) => {
        if(e.target.files[0]){
            const data = new FormData();
            data.append('file', e.target.files[0]);
            uploadMedia(data).then((res) => {
                if(res.data.responseData.result.fileUrl){
                    let params = {
                        bookingId,
                        programId,
                        camperId,
                        medicalDocument: res.data.responseData.result.fileUrl
                    }
                  
                    updateBookingKeyService(params).then(res => {
                        if(res?.data?.statusCode){
                            getCamperBookingDetail();
                            e.target.value = null;
                        }
                    })
                }
            })
        }
        
    }
    const handleDeleteCard = (cardId) => {
        setIsDeletePopup(true); 
        setDeleteCardToken(cardId)
      }
      const deleteCardAction = () => {
        const params = {
            userId,
            cardToken :deleteCardToken,
        }
        //added api call to remove the card using card id. 
        deleteCardService(params).then( res => {
            if(res.status){
                getCards()
                setCardList(cardList.filter(card =>card.card.id !== deleteCardToken));
                setIsDeletePopup(false)
            }
        }).catch(error => {
            console.log(error)
        })
        .finally(() => {
            setIsDeletePopup(false)
        }
        )
        
      }
      const handlePrimaryCardAction = () => {
        
            const params = {
                cardToken: holdPrimaryId,
                userId,
            }
            markPrimaryCard(params).then( res => {
            if(res.status){
                setIsSwitchPrimaryCard(false)
                getCards();
                setPrimaryCardId(holdPrimaryId);
            }
        }).catch(error => {
            console.log(error)
        })
        .finally(() => {
            setIsSwitchPrimaryCard(false)
        }
        )
      }
      const handlePrimaryCard = (id) => {
            setHoldPrimaryId(id)
            setIsSwitchPrimaryCard(true)
      }


      const handleEMIDateChange = () => {
  
        if(selectEmiDate){
            let params = {
                bookingId,
                emiId: activeEMI._id,
                emiDate:  moment(selectEmiDate, 'YYYY-MM-DD').utc().startOf('day').valueOf(),
            }
            setUpdateEMIDateModal(false);
            setActiveEMI('');
            updateBookingDateService(params).then(res => {
                if(res.data.statusCode){
                    notification.open({
                        description: 'Date Updated successfully',
                    });
                    getCamperBookingDetail(); 
                } 
            })

        }else{

        }
      }



      const  disabledDate = (current) => {
        return current && current < moment().endOf('day');
    }
  
     
    const showProductInfo = (pp) => {
        setActiveProduct(pp)
        setIsViewProducts(true);
     }
     const showProductPaymentInfo = (pp) => {
        setActiveProduct(pp)
        setPaymentInfoModal(true);
     }
    const handleCloseProductModal = () => {
        setIsViewProducts(false)
    }

    const addAddonsToList = (totalQuantity, addonId,selectedSize,selectedColor,) => {
        if(totalQuantity> 0 ){
            const addonItem = activeAddProduct?.subItems.filter(item => item.id === addonId)[0]
            const _newAddon = {
                count:totalQuantity,
                price:addonItem?.price,
                title:addonItem?.title,
                itemId: addonId,
            }
            if(selectedSize){
                _newAddon['sizes'] = selectedSize.value;
            }
            if(selectedColor){
                _newAddon["color"] = selectedColor?.value;
            }
            const _PreviousAddon = addons.filter(item => item.itemId !== addonId); 
            setAddons([..._PreviousAddon.filter(obj => Object.keys(obj).length !== 0 || obj.constructor !== Object), _newAddon])
        }else{
            const _PreviousAddon = addons.filter(item => item.itemId !== addonId); 
            setAddons(_PreviousAddon)
        }
    }

    const handleShowModalProductDetail = (item, i) => {  
        setActiveProductIndex(i)   
        setIsViewAddProducts(true);
        const _isExistingItemDetails = getCartItemsProducts(item._id, item)
        if(!_isExistingItemDetails){
            setActiveAddProduct(item)
            setCurrentCount(item.count);
        }
        
    }
    const calculateTotalProductPrice = () => {
        const totalPrice = addons.reduce((totalPrice, addon ) => Number(totalPrice) + (Number(addon.count) * Number(addon.price)), activeAddProduct? activeAddProduct?.price * currentCount : 0) 
        return totalPrice;
    }

    const calculateTotalProductPrice1 = (item) => {
        const totalPrice = item.subItems.reduce((totalPrice, addon ) => Number(totalPrice) + (Number(addon.count) * Number(addon.price)), item? (item.price * item.count) : 0) 
        return totalPrice;
    }

    const handleAddCloseModal = () => {
        setIsViewAddProducts(false);
        setActiveAddProduct([])
        setAddons([])
        setSelectedColor('')
        setSelectedSize('')
        setSelectedColorErr('')
        setSelectedSizeErr('')
        setCurrentCount(1)
        setExistingWarning('')
        setActiveCartId('')
    }

    const handleAddToCartCountChange = (type) => {
        if(type === 'add'){
            setCurrentCount(currentCount + 1);     
        }else{
            if(currentCount !== 1){
                setCurrentCount(currentCount - 1);
            }
        }
        const _index = campRelatedProducts.indexOf(activeAddProduct);
        handleStoreCount(type , _index)
    }
    

    const isProductInCart = (id) => {
       return  passDataArr?.filter(item => item.itemId === id).length > 0 
    }

    const getSubItemDetails = (id) =>  {
        return passDataArr.find(p => p.itemId === id)
    }

    const getSubItemPrice = (id) =>  {
        if(passDataArr?.find(p => p?.itemId === id)){
            if(passDataArr.find(p => p.itemId === id)?.subItems?.length > 0){
                return passDataArr.find(p => p.itemId === id)?.subItems?.reduce((acc, item) => (acc + (item.price * item.count)), 0)
            }
        }
        return 0;
    }

    const isAllSubitemsCountNonZero = (id) =>  {
        if(passDataArr?.find(p => p?.itemId === id)){
            if(passDataArr.find(p => p.itemId === id)?.subItems?.length > 0){
                return passDataArr.find(p => p.itemId === id)?.subItems?.reduce((acc, item) => ((item.count > 0) || acc), false);
            }
        }
        return false;
    }
    const closeActiveQuestionModel = () => {
        setAnswerModal(false)
        getCamperBookingDetail();
    }
    const getCartItemsProducts = (itemId, item) => {
        setLoading(true);
        let _campRelatedProducts = [...campRelatedProducts];
        const _index = _campRelatedProducts.indexOf(item)
        let query =`?type=2&itemId=${itemId}`
        if(bookingId){
            query += `&bookingId=${bookingId}`
        }
        if(userId){
            query += `&userId=${userId}`
        }
        if(programId){
            query += `&programId=${programId}`
        }
        if(camperId){
            query += `&camperId=${camperId}`
        }
        getCartProductsService(query).then(response => {
            if(response?.data?.statusCode){
                if(response?.data?.responseData?.result?.length){
                    const _existingItemDetails = response?.data?.responseData?.result[0]
                    if(_existingItemDetails){
                        setExistingWarning("Imported from Parent's cart")
                        setCurrentCount(_existingItemDetails.count)
                        if(_existingItemDetails?.color){
                            setSelectedColor(_existingItemDetails.color)
                        }
                        if(_existingItemDetails?.sizes){
                            setSelectedSize(_existingItemDetails?.sizes)
                        }
                       setActiveCartId(_existingItemDetails.cartId);
                        const _subItems = [..._existingItemDetails?.subItems]
                        const _mergedArray = _subItems.map(item2 => {
                            const matchedItem = item.subItems.find(item1 => item1.id === item2.itemId);
                            return matchedItem ? { ...item2, 
                                                    ...matchedItem, 
                                                    selectedSize: item2?.sizes,
                                                    selectedColor: item2.color,
                                                } : item2;
                          });
                        if(_subItems.length > 0){                            
                            setAddons(_mergedArray)
                        }
                        item.subItems = [..._mergedArray]
                        item.count = _existingItemDetails.count
                        setActiveAddProduct(item)
                        _campRelatedProducts[_index] = item;
                        setCampRelatedProducts(_campRelatedProducts)
                        const _passDataArr = [...passDataArr]
                        _passDataArr.push({
                            cartId: _existingItemDetails.cartId,
                            itemId: _existingItemDetails.itemId,
                            price: calculateTotalProductPrice1(_existingItemDetails),
                            subItems:[..._existingItemDetails.subItems]
                        })
                        setPassDataArr(_passDataArr);
                    }
                    setLoading(false);
                    return true;
                }else {
                    setLoading(false);
                    return false
                }

            }
            return false
        }).catch(e =>  setLoading(false)).finally( () => setLoading(false));
    }

    const updateCartItemsProducts = (item) => {
        setLoading(true);
        let _campRelatedProducts = [...campRelatedProducts];
        const _index = _campRelatedProducts.indexOf(item)
        let data = {
            itemId: item._id,
            color: selectedColor,
            sizes: selectedSize,
            count: currentCount,
            bookingId: bookingId,
            camperId: camperId,
            cartId: activeCartId,
            userId,
            programId, 
        }
        if(addons.length > 0){ 
            const _addons =  addons.filter(itm => itm.count > 0)              
            data.subItems = _addons.map(item => ({
                count:item.count,
                color:Array.isArray(item.color) ? item.selectedColor : item.color,
                price:item.price,
                title:item.title,
                itemId:item.itemId,
                sizes:Array.isArray(item.sizes) ? item.selectedSize : item.sizes,
            }))
             
        }else {
            data.subItems =[];
        }


        updateCartProductsService(data).then(response => {
            if(response?.data?.statusCode){              
                let _passDataArr = [...passDataArr];
                let _totalPrice
               
                _totalPrice = item?.subItems?.length > 0 ?
                    (item.count * item.price) + addons.reduce((_total, i) =>  (i.count * i.price) + _total, 0)
                    : currentCount * item.price;
                const _mergedArray = addons.map(item2 => {
                    const matchedItem = item.subItems.find(item1 => item1.id === item2.itemId);
                    const { count, ...restOfItem2 } = item2
                    return matchedItem ? {...restOfItem2,
                                            ...matchedItem, 
                                            selectedSize: item2?.sizes,
                                            selectedColor: item2.color,
                                            count,
                                        } : item2;
                });
                let itemIndex = _passDataArr.findIndex(_item => _item.itemId === item._id)
                if(itemIndex !== -1){
                    _passDataArr[itemIndex] = {
                        cartId: activeCartId,
                        itemId: item._id,
                        price: _totalPrice,
                        subItems:[..._mergedArray]
                    }
                }else{
                    _passDataArr.push({
                        cartId: activeCartId,
                        itemId: item._id,
                        price: _totalPrice,
                        subItems:[..._mergedArray]
                    })
                }

                

                  item.count = currentCount 
                  item.subItems =[..._mergedArray]
                _campRelatedProducts[_index] = item
                setPassDataArr(_passDataArr); 
                setCampRelatedProducts(_campRelatedProducts);
                setLoading(false);
                handleAddCloseModal()
            }
        }).catch(e =>  setLoading(false)).finally( () => setLoading(false));
    }

    const handleProductActionModal = () => {
        setConfirmCancelProductModal(false)
        setProductCancellationType(cancellationOptions[0]);
        setActiveProductData({});
        setProductRefundAmount(0)
        setProductRefundAmountErr('')
        setProductRefundMode(productRefundModeOptions[0]);
        setSelectedProductRefundTransaction({});
    }

    useEffect(() => {
        if(payments?.length  && confimCancelBookingModal) {
            // Both action types now start from the SAME base list, so the two dropdowns can never
            // disagree about which transactions exist. They used to filter independently - REFUND
            // ONLY kept paymentStatus === "succeeded" while CANCEL AND REFUND checked no status at
            // all - so the same booking showed a different number of transactions depending on
            // which action was selected, and CANCEL AND REFUND offered payments that had failed and
            // could never be refunded.
            //
            // The base rule is the one REFUND ONLY already used, so every transaction that was
            // refundable before still is. Entries with no paymentStatus at all are kept: on older
            // bookings that is simply a payment recorded before status tracking existed, not a
            // failure. ('failed' never appears after 'succeeded' for a transaction, so this cannot
            // hide a real payment the way the "pending" placeholder used to - see the guard in
            // appUtils.combinePaymentArrByTransactionId.)
            const refundable = payments.filter(py => !py?.paymentStatus || py.paymentStatus === "succeeded");

            if( cancellationType.value === 3){
                setPaymentList(refundable);
            }else if(cancellationType.value === 4){
                // Cancelling a camper never carries an admin-added extra charge with it - those are
                // refunded on their own through REFUND ONLY. Longstanding behaviour, kept as is.
                setPaymentList(refundable.filter(py => py?.metadata?.type !== 'additionalCharge'));
            }
            }
    }, [confimCancelBookingModal, cancellationType.value])


    const handleProductRefundAmount = e => {
        setProductRefundAmount(e)
        setProductRefundAmountErr('')
    }


    const handleAddInsurance = () => {
        if(programDetails?.startDate < Date.now()){
            return
        }
        setInsuranceModal(true)
    }

    // Insurance card's button: offered + under the maximum → 'add' before the program starts,
    // 'closed' (the "can not be purchased" note) after. Same rules as the old section.
    const insuranceAddState = !showInsurance?.some(i => i.isShowInsurance === true) || addedinsurance?.length === MAX_INSURANCE_PRODUCTS
        ? null
        : (programDetails?.startDate > Date.now() ? 'add' : 'closed');

    const InsurancePurchaseCallback = () => {
        setInsuranceModal(false)
        getCamperBookingDetail()
        getRefundInfo()
    }

    const handleCancellationAction = e => {
        if(e.value ===5){
            handleCloseRefundCancelCamper();
            handleCamperChange(camperId)
            handleMetaDataChange(bookingId, allData.bookingNumber, programId)
            setChargeModal(true);
        }
       
        setSelectedTransaction({});
        setProgramRefundAmount(0);
        setCancellationType(e);
        setCancelRefundActionError('');
        }
    const handlePaymentModal = (pp) => {
            setActiveProduct(pp)
        setShowPaymentModal(!showPaymentModal)
    }
    const handleCloseShowPayementModal = () => {
        setShowPaymentModal(false);
        productListByBooking();
        getRefundInfo();
    }
    const handleEmiPay = (_emi) => {
        if(isPayBtnDisabled){
            return;
        }
        if(enablePayNowTimerRef.current) {
            clearTimeout(enablePayNowTimerRef.current);
            enablePayNowTimerRef.current = null;
        }
        setErrorMsg('');
        setActivePaymentObject({ ..._emi, isEmiPayment: 1 });
        setPaymentModal(true);
        setAmount(_emi?.emiAmount);
    }
    const handleRemainingAmountPay = (data) => {
        if(isPayBtnDisabled){
            return;
        }
        if(enablePayNowTimerRef.current) {
            clearTimeout(enablePayNowTimerRef.current);
            enablePayNowTimerRef.current = null;
        }
        setErrorMsg('');
        setActivePaymentObject2(data)
        setPaymentModal(true)
        setAmount(data?.remainingAmount)
    }

    const handleStatusChange = () => {
        setIsCommuterModal(true)
        
    }
    const toggleCommuter = (reasonForChange) => {
        const _isCommuter = !isCommuter
        setIsCommuter(_isCommuter)
        setIsCommuterModal(false)
        const params = {
            bookingId: bookingId,
            programId: programId,
            camperId: camperId,
            isCommuter: _isCommuter,
            reasonForChange
        }
        updateCommuterService(params).then(res => {
            notificationMsg(res.data.statusCode, res.data.responseData.message);
            refresh()
        })
    }
    const refresh = () => {
        getCamperBookingDetail()
        getRefundInfo()
    }

    const closeScheduleEmiModal = (action= 0) => {
        setEmiAction(false)
        if(deleteEmi){ 
            setActiveEMI(false)
            setDeleteEmi(false)
        }
        action ===1 && refresh()
    }

    const handleUpdateEmiDate = (_emi) => {
        setUpdateEMIDateModal(true); 
        setActiveEMI(_emi)
        const _currentEmiDate = momentTz.utc(parseInt(_emi.emiDate)).tz(userTimeZone)
        setSelectEmiDate(_currentEmiDate)
    }

    // Union of the two checks the old layout made separately (the profile card only looked at
    // status 2; the payment card also counted isCancelled and status 4 = canceled and refunded).
    const bookingStatus = allData?.campers?.status;
    const isBookingCanceled = !!allData?.campers?.isCancelled || bookingStatus === 2 || bookingStatus === 4;
    const isBookingRefunded = bookingStatus === 3 || bookingStatus === 4;

    // Charge & Discounts. Same values and conditions as the old panel; only the labels (design) and
    // the empty display (`$0.00` instead of 0 / No / NONE) changed. Don't compute new totals here:
    // see docs/booking-page-redesign.md, "Money".
    const campersData = allData?.campers;
    const couponDiscountShown = (campersData?.couponDiscount ?? 0) > 0 ? campersData.couponDiscount : (campersData?.applicableCouponAmount ?? 0);
    const insuranceShown = allData?.payment?.amount ? calculateInsuranceCamperDisplay(allData?.insurance, campersData?.insuranceData) : 0;
    const chargeLines = allData ? [
        { label: 'Coupon Code', value: allData.couponValue ? allData.couponCode : 'None' },
        { label: 'Gift Card', value: money(allData.giftCardValue) },
        { label: 'Coupon Applied', value: money(allData.couponValue) },
        { label: 'Discount Applied', value: money(couponDiscountShown > 0 ? couponDiscountShown : 0) },
        // The program's own discount. "Discount Applied" only reads the coupon fields, so without
        // this line the panel jumped from the program fee to a lower booking total unexplained.
        { label: 'Program Discount', value: money(campersData?.discountPrice) },
        { label: 'Multi Program Discount', value: money(campersData?.multiProgramDiscount) },
        { label: 'Sibling Discount', value: money(campersData?.siblingDiscount) },
        // Tier label from setProgramPrice (Early Bird Program Fee / Program Fee / Late Registration Fee).
        { label: campersData?.isCommuter ? 'Program Day Only Fee' : programPriceText?.label, value: money(programPriceText?.value) },
        { label: 'Convenience Fee', value: money(campersData?.convenienceFee) },
        // Under `campers`, where `bookingcamperdetail` projects it (`bookingdetail` puts it at the
        // top level). The fee this booking was charged, from the booking snapshot.
        { label: 'Non-Refundable Fee', value: money(campersData?.registerNonRefundFee) },
    ] : [];
    const chargeTotals = allData ? [
        {
            label: 'Booking Total',
            value: money(allData.finalPayAmount
                ? (allData.totalAmount ? allData.totalAmount : allData.payment?.amount)
                : (allData.totalAmount || 0) + (allData.payment?.applicationFeeAmount || 0)),
        },
        { label: 'Insurance', value: money(insuranceShown) },
    ] : [];

    // Check-in readiness (W14). Only checks the page can compute; the list itself is open question Q4.
    // Group assignment comes from the Group Organizer (A2), with the director's Approved override.
    // The program's document sliders come on the camper (bookingCamperDetail).
    const missingDocuments = allData ? countMissingDocuments(allData.campers, allData.isDisclaimer, allData.campers) : 0;
    const medicalApplies = allData ? getApplicableDocuments(allData.campers, allData.campers).medicalClearance : false;
    const hasBalanceDue = allData?.remainingAmount > 0 || (emis || []).some(e => e.status === 2 || e.status === 3);
    const readinessItems = allData ? [
        { label: missingDocuments ? `${missingDocuments} document${missingDocuments > 1 ? 's' : ''} missing` : 'Documents complete', done: !missingDocuments, target: 'documents' },
        medicalApplies && { label: 'Medical review approved', done: medicalDocumentStatus === 1, target: 'documents' },
        // Not scored when the program has no saved groups (it doesn't use the organizer); otherwise
        // done when the participant is in a group or a director approved it without one.
        !allData.groupsSaved
            ? { label: 'No groups for this program', pending: true, target: 'group' }
            : allData.groupAssignment
                ? { label: 'Assigned to a group', done: true, target: 'group' }
                : { label: groupApproved ? 'Group approved' : 'Not assigned to a group', done: groupApproved, target: 'group' },
        { label: hasBalanceDue ? 'Balance due' : 'Balance settled', done: !hasBalanceDue, target: 'balance' },
    ].filter(Boolean) : [];

    // Sidebar nav: one link per card on the page, same conditions as the cards themselves.
    const navSections = allData ? [
        { id: 'participant', label: 'Participant / Guardian', icon: User },
        { id: 'questions', label: 'Questions', icon: HelpCircle },
        { id: 'medical', label: 'Medical', icon: Stethoscope },
        { id: 'documents', label: 'Documents', icon: FileText, badge: missingDocuments },
        { id: 'group', label: 'Group Assignment', icon: Users },
        allData.campers?.uslCustomerEntity?.membership_id && { id: 'usal', label: 'USAL', icon: BadgeCheck },
        { id: 'insurance', label: 'Added Insurance', icon: ShieldCheck },
        programDetails?.additionalExp?.length > 0 && { id: 'experience', label: 'Additional Experience', icon: Sparkles },
        { id: 'products', label: 'Products', icon: Package },
    ].filter(Boolean) : [];

    return(
        <div className="body_container pb-4 pt-5">
            {loader ? <div className="page_loader"><ProgramLoader /></div> : ''}
            <div className="container">
                <ShowEmptyFieldsContext.Provider value={showEmptyFields}>
                <BookingDetailLayout
                    header={allData ? <BookingHeader
                        programName={allData?.campers?.programName}
                        programCode={allData?.campers?.programCode}
                        campName={allData?.campName}
                        bookingNumber={allData.bookingNumber}
                        bookingDate={convertTimeToCurrentTimeZone(allData.bookingDate, userTimeZone, 'MM/DD/YY hh:mm a')}
                        isCanceled={isBookingCanceled}
                        isRefunded={isBookingRefunded}
                        onBack={() => history.goBack()}
                        primaryAction={<HeaderButton icon={SquarePen} onClick={() => setConfimCancelBookingModal(true)}>Manage Registration</HeaderButton>}
                        navigation={<PrevNextNav neighbors={neighbors} onGo={goToRegistration} />}
                        actions={<>
                            <HeaderButton icon={History} onClick={() => setIsAuditTrailModal(true)}>
                                Activity{allData?.audits?.length ? ` (${allData.audits.length})` : ''}
                            </HeaderButton>
                            <HeaderButton
                                icon={LifeBuoy}
                                href={buildSupportMailto({
                                    isTeamsEZ: props.isTeamsEZ,
                                    bookingNumber: allData.bookingNumber,
                                    participantName: [allData?.campers?.firstName, allData?.campers?.lastName].filter(Boolean).join(' '),
                                    programName: allData?.campers?.programName,
                                    programCode: allData?.campers?.programCode,
                                    bookingUrl: window.location.href,
                                })}
                                title={`Email ${getSupportEmail(props.isTeamsEZ)}`}
                                // A web mail handler (e.g. Gmail) would otherwise replace this page.
                                target="_blank"
                                rel="noopener noreferrer"
                            >
                                Contact Support
                            </HeaderButton>
                        </>}
                    /> : null}
                    sidebar={<>
                    {allData ? <ReadinessCard items={readinessItems} /> : null}
                    {allData ? <SectionNav sections={navSections} showEmpty={showEmptyFields} onToggleShowEmpty={toggleShowEmptyFields} /> : null}
                    {allData ? <div className="booking-detail-page tw-flex tw-flex-col tw-gap-4">
                        <h2 className="tw-m-0 tw-text-xs tw-font-semibold tw-uppercase tw-tracking-wider tw-text-neutral-500">Payment</h2>
                        <ChargesCard
                            lines={chargeLines}
                            totals={chargeTotals}
                            finalAmount={allData.finalPayAmountReason ? { amount: allData.finalPayAmount, reason: allData.finalPayAmountReason } : null}
                        />
                        <BalanceCard
                            emis={emis}
                            remainingAmount={allData.remainingAmount}
                            nextPayment={allData.isEmi?.allEmiRemains?.length ? { date: getNextPaymentDate(allData), left: allData.isEmi?.remaingMonth ? allData.isEmi.remaingMonth : 0 } : null}
                            formatDate={(date, format) => convertTimeToCurrentTimeZone(date, userTimeZone ?? '', format)}
                            payMuted={isPayBtnDisabled}
                            onScheduleEmi={() => setEmiAction(true)}
                            onEditEmiDate={handleUpdateEmiDate}
                            onUpdateEmiAmount={_emi => {setAmountUpdateModal(true); setRemainingAmount(_emi.emiAmount); setEmiId({..._emi, remainingAmount: allData?.remainingAmount})}}
                            onDeleteEmi={_emi => {setDeleteEmi(true); setActiveEMI(_emi); setEmiAction(true)}}
                            onPayEmi={handleEmiPay}
                            onUpdateRemaining={() => {setAmountUpdateModal(true); setRemainingAmount(allData.remainingAmount); setActivePaymentObject2(allData)}}
                            onPayRemaining={() => handleRemainingAmountPay(allData)}
                        />
                        <PaymentsList
                            payments={payments}
                            fallback={{ method: allData.payment?.method, transactionId: allData.payment?.transaction_id, amount: allData.payment?.amount }}
                            emiDateFor={emiId => convertTimeToCurrentTimeZone(emiDateMap.get(emiId), userTimeZone, 'DD MMM, YYYY')}
                            formatDate={date => convertTimeToCurrentTimeZone(date, userTimeZone, PaymentDateFormat)}
                            dueLabel={date => moment(date).format('MMM DD, YYYY')}
                            canceled={isBookingCanceled}
                            refunded={isBookingRefunded}
                            canRespondDispute={props.userProfile?.UserType === 2 || props.userProfile?.UserType === 11}
                            onDisputeClose={getCamperBookingDetail}
                        />
                        {allData.editNotes?.length ? <PaymentNotesCard notes={allData.editNotes} /> : null}
                    </div> : null}
                    </>}
                >
                    {allData ? <CardRow>
                    <ParticipantCard
                        camper={allData.campers}
                        age={allData?.campers?.dob ? _calculateAge(allData.campers.dob) : null}
                        activityInterest={allData.UserType
                            ? props.category.filter(el => allData?.campers?.activityInterest?.find(i => el._id === i.category)).map(n => n.name).join(', ')
                            : undefined}
                        commuter={
                            allData?.campers?.byDates === 1
                                ? (checkHasCommuter(allData?.campers?.additionalDates) ? { value: !!allData.campers?.isCommuter, editable: false } : null)
                                // Any of the three commuter fields means the program offers a day-only
                                // rate: the early/late prices are optional per-tier overrides, so a
                                // program can carry one with no standard commuterPrice. Testing
                                // commuterPrice alone hid this toggle on such programs.
                                : (hasCommuterOption(allData?.campers)
                                    ? { value: isCommuter, editable: true, onToggle: handleStatusChange, auditCount: isCommuterHistory?.length || 0, onShowAudits: () => setIsCommuterHistoryModal(true) }
                                    : null)
                        }
                    />
                    <GuardianCard
                        camper={allData.campers}
                        isGuest={!allData?.campers?.UserType}
                        signatureLine={allData.isDirectorBooking ? null : getSignature(allData?.campers?.signatureLine)}
                        userDetailUrl={allData.userId ? `/users/detail/${allData.userId}` : null}
                        onResendConfirmation={handleResendBookingEmail}
                        actions={allData.userId
                            ? <>
                                {canMessageUser
                                    ? <ActionButton variant="primary" icon={MessageSquare} onClick={handleMessageUser}>Message User</ActionButton>
                                    : null}
                                <ActionButton variant="primary" icon={FilePlus} onClick={() => setIsAddNoteModal(true)}>Add Note</ActionButton>
                            </>
                            : null}
                    />
                    </CardRow> : null}

                    {allData ? <QuestionsCard
                        camperQuestions={allData?.campers?.questions || []}
                        bookingQuestions={allData?.questions || []}
                        onEdit={() => handleShowEditModal(allData?.campers?.questions)}
                    /> : null}

                    {allData ? <MedicalCard camper={allData.campers} cleanList={removeStr} /> : null}
                    {allData ? <DocumentsCard
                        camper={allData.campers}
                        program={allData.campers}
                        isDisclaimer={allData.isDisclaimer}
                        medicalApproved={medicalDocumentStatus === 1}
                        onToggleApproval={handleUserStatusChange}
                        medicalEmail={medicalEmail}
                        onMedicalEmailElapsed={handleMedicalEmailElapsed}
                        onOpenForm={openBookingForm}
                        onUploadMedical={e => handleFileChange(e, camperId)}
                        onSendReminder={handleSendDocumentReminder}
                        sendingReminder={sendingReminder}
                    /> : null}
                    {allData ? <GroupCard
                        groupCode={allData.groupCode || allData.campers?.groupCode}
                        groupAssignment={allData.groupAssignment}
                        groupsSaved={!!allData.groupsSaved}
                        approved={groupApproved}
                        onToggleApproved={handleGroupApprovalToggle}
                    /> : null}

                    {allData?.campers?.uslCustomerEntity?.membership_id ? <UsalCard entity={allData.campers.uslCustomerEntity} /> : null}
                    {allData ? <InsuranceCard
                        insuranceData={allData.campers?.insuranceData || []}
                        insuranceResponse={allData.campers?.insuranceResponse}
                        addState={insuranceAddState}
                        onAdd={handleAddInsurance}
                    /> : null}
                    {programDetails?.additionalExp?.length > 0 ? <AdditionalExperienceCard
                        experiences={additionalExperience || []}
                        auditCount={additionalExpAudit?.length || 0}
                        onShowAudits={() => setIsAdditionalExpAuditModal(true)}
                        onAdd={() => {setaddExpModal(true); setaddExpAction(1)}}
                        onRemove={exp => {setaddExpModal(true); setaddExpAction(2); setActiveAddExp(exp)}}
                        renderHtml={getHtml}
                    /> : null}
                    {allData ? <ProductsCard
                        products={userProductList || []}
                        onAdd={() => setCampRelatedProductsModal(true)}
                        hasPaymentHistory={showProductPayHistory}
                        onShowInfo={showProductInfo}
                        onEdit={handleProductCancelRefund}
                        onPaymentHistory={showProductPaymentInfo}
                        onPayNow={handlePaymentModal}
                    /> : null}
                </BookingDetailLayout>
                </ShowEmptyFieldsContext.Provider>
            </div>


            <Modal show={confimCancelBookingModal} centered>
                            <Modal.Title>
                                <span className="modal_close" onClick={handleCloseRefundCancelCamper}><i className="icon-cross" /></span>
                            </Modal.Title>
                                <Modal.Body>
                                    <div className='text-center p-4'>
                                        {programRefundAmount ? (cancellationType.value === 3 || cancellationType.value === 4) &&  <h4>Refundable amount: ${programRefundAmount.toFixed(2)}</h4> : ''}
                                        <div className="form-group">
                                        <label>Select Action Type</label>
                                            <ReactSelect
                                                className="form-control ms-3"
                                                placeholder="Select Action Type"
                                                classNamePrefix="cm_select"
                                                value={cancellationType}
                                                onChange={handleCancellationAction}
                                                options={camperCancellationOptions}
                                            />
                                           {CancelRefundActionError &&  <span className='text-danger mt-2 ms-3'>{CancelRefundActionError}</span>}
                                        </div>
                                        {(cancellationType.value === 3 || cancellationType.value === 4) &&
                                            <div className="form-group">
                                            <label>Select Transaction to refund</label>
                                                <ReactSelect
                                                    className="form-control ms-3"
                                                    placeholder="Select Transaction"
                                                    classNamePrefix="cm_select"
                                                    onChange={e => (handleRefundTransaction(e))}
                                                    options={paymentList ? paymentList.map(p => (
                                                        {label: `Amount: $${p.amount} - Date: ${moment.utc(p.paymentDate).format('MMM DD, YYYY')}`, value:p.transaction_id}))
                                                        : [{label: "No transaction Available", value: 0}]}
                                                />
                                            </div>
                                        }
                                        {
                                            selectedTransaction?.transaction_id && 
                                            <div className='p_arr ms-4 '>
                                                <p className='d-flex justify-content-between align-items-center'><span className="color_black">Payment Date :</span> {convertTimeToCurrentTimeZone(selectedTransaction?.paymentDate,userTimeZone, PaymentDateFormat) || 'N/A'}</p>
                                                <p className='d-flex justify-content-between align-items-center'><span className="color_black">Transaction Id:</span> {selectedTransaction?.transaction_id || 'N/A'}</p>
                                                <p className='d-flex justify-content-between align-items-center'><span className="color_black">Payment Method:</span> {selectedTransaction?.method}</p>
                                                <p className='d-flex justify-content-between align-items-center'><span className="color_black">Amount:</span> ${selectedTransaction?.amount.toFixed(2)}</p>
                                                <PaymentDetails transactionId={selectedTransaction.transaction_id }/>   
                                                {      selectedTransaction?.refunds?.length > 0  ?
                                                                <>
                                                                <div className='d-flex justify-content-between'>
                                                                  <span className='p-2' style={{background:'blue'}}>Payment Refunded</span>
                                                                </div>
                                                                    {
                                                                        selectedTransaction?.refunds?.map( rf =>
                                                                            <>  
                                                                                <div style={{color:'blue'}} >
                                                                                <p className='d-flex justify-content-between align-items-center'><span >Refund Issue Date :</span> 
                                                                                    {convertTimeToCurrentTimeZone(rf?.paymentDate, userTimeZone, PaymentDateFormat) || 'N/A'}
                                                                                </p>
                                                                                <p className='d-flex justify-content-between align-items-center'><span >Refunded Amount:</span> ${rf?.amount.toFixed(2)}</p>
                                                                                <p className='d-flex justify-content-between align-items-center'><span >Refund Status:</span>
                                                                                {
                                                                                    rf.status === 'pending' ? 
                                                                                    <span className = 'mt-0' style={{fontSize:"10px"}}>
                                                                                        <i>Pending</i>
                                                                                    </span>
                                                                                    :
                                                                                    <span className = 'mt-0' style={{fontSize:"10px"}}>
                                                                                        <i>Successful</i>
                                                                                    </span>
                                                                                }
                                                                                </p>
                                                                                <hr/>
                                                                                </div>
                                                                                
                                                                                
                                                                            </>
                                                                    )
                                                                    }
                                                                </>
                                                                : (selectedTransaction?.paymentStatus === 'succeeded' ? <span className='p_cat_text' style={{background:'green'}}>Payment successful</span> 

                                                                : '')

                                                }
                                            </div>
                                        }
                                        {!isOldBooking && !isAdditionalChargeTransaction && selectedTransaction?.transaction_id && (cancellationType.value === 3 || cancellationType.value === 4) &&
                                            <div className="form-group">
                                            <label>Refund Scope</label>
                                                <ReactSelect
                                                className="form-control ms-3"
                                                classNamePrefix="cm_select"
                                                value={programRefundScope}
                                                onChange={handleProgramRefundScopeChange}
                                                options={programRefundScopeOptions} />
                                            </div>
                                        }
                                        { selectedTransaction?.transaction_id  && (cancellationType.value === 3 || cancellationType.value === 4) ?
                                        programRefundAmount ?
                                            (isOldBooking || isAdditionalChargeTransaction || programRefundScope.value === 'programOnly' ?
                                            <Fragment>
                                                    <div className='form-group'>
                                                    <label>Enter Refund Amount</label>
                                                        <CustomNumber
                                                            className={`form-control ms-3 ${newRefundAmountErr ? 'is-invalid' : ''}`}
                                                            formatter={value => `$${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                                                            change={e => (setNewRefundAmount(e), setNewRefundAmountErr(''))}
                                                            value={newRefundAmount}
                                                            min={0}
                                                            precision={2}
                                                            error={newRefundAmountErr}
                                                            pHolder="Enter Refundeble Amount"  />
                                                            {newRefundAmountErr && <span className='text-danger mt-2'>{newRefundAmountErr}</span>}
                                                    </div>
                                            </Fragment> : '') :
                                            <h5>Fully Refunded</h5>

                                            :''
                                        }
                                        <div className="d-flex justify-content-center mt-5 mb-4">
                                                <button className={`btn btn-primary rounded-0  btn_anim ${btnLoader ? 'show_anim' : ''}`} onClick={btnLoader ? null : handleCancelRefundBookingAction}>PROCEED</button> 
                                                
                                        </div>
                                    </div>
                                </Modal.Body>
            </Modal> 

            <Modal
                show={paymentInfoModal}
                animation={false}
                centered>
                <Modal.Body>
                    <span className="modal_close" onClick={() => setPaymentInfoModal(false)}><i className="icon-cross" /></span>
                    <div className='text-center p-4'>
                    { activeProduct?.paymentArr?.length > 0 ? 
                                    activeProduct?.paymentArr?.map(pArr => (
                                        <div className='p_arr'>
                                            <p className='d-flex justify-content-between align-items-center'><span className="color_black">Payment Date :</span> {convertTimeToCurrentTimeZone(pArr.paymentDate, userTimeZone, PaymentDateFormat)}</p>
                                            <p className='d-flex justify-content-between align-items-center'><span className="color_black">Transaction Id:</span> {pArr.transaction_id || 'N/A'}</p>
                                            <p className='d-flex justify-content-between align-items-center'><span className="color_black">Payment Method:</span> {pArr.method}</p>
                                            <p className='d-flex justify-content-between align-items-center'><span className="color_black">Amount:</span> ${pArr.amount.toFixed(2)}</p>
                                            <PaymentDetails transactionId={pArr.transaction_id }/>   
                                                {
                                                            pArr?.paymentStatus === 'failed' ? 
                                                            <>
                                                            <p style={{ fontSize: "12px" , color:'red'}}><i>{pArr?.failed?.errorDescription}   </i></p>
                                                            <p style={{color:'red'}} className='d-flex justify-content-between align-items-center'> <span className='p_cat_text' style={{background:'red'}}>Payment Failed</span> {
                                                            convertTimeToCurrentTimeZone(pArr?.failed?.paymentDate, userTimeZone, PaymentDateFormat)
                                                            }</p>
                                                           
                                                            </>
                                                            : ''

                                                } 
                                                {      pArr?.refunds?.length > 0  ?
                                                                <>
                                                                <div className='d-flex justify-content-between'>
                                                                  <span className='p_cat_text' style={{background:'blue'}}>Payment Refunded</span>
                                                                </div>
                                                                    {
                                                                        pArr?.refunds?.map( rf =>
                                                                            <>  
                                                                                <div style={{color:'blue'}} className='d-flex justify-content-between align-items-center mb-0'>
                                                                                    <span>Refunded Amount : $ {rf?.amount}</span>
                                                                                    {rf.status === 'pending' && <span className = 'mt-0' style={{fontSize:"10px"}}><i>(Pending)</i></span>}
                                                                                    <span> {convertTimeToCurrentTimeZone(rf?.paymentDate, userTimeZone,PaymentDateFormat)}</span>
                                                                                </div>
                                                                                
                                                                                
                                                                            </>
                                                                    )
                                                                    }
                                                                </>
                                                                : (pArr?.paymentStatus === 'succeeded' ? <span className='p_cat_text' style={{background:'green'}}>Payment successful</span> 

                                                                : '')

                                                }
                                        </div>
                                    ))
                                    :
                                    <h5>Payment under process</h5>
                                }
                    </div>
                </Modal.Body>
            </Modal>

            <Modal
                show={answerModal}
                animation={false}
                centered>
                <Modal.Body>
                    <span className="modal_close" onClick={closeActiveQuestionModel}><i className="icon-cross" /></span>
                 { (activeQuestions.length> 0) && 
                    <QuestionsComponent 
                    questions= {activeQuestions}
                    setQuestions={setActiveQues}
                    source={2}
                    /> }
                 <div className='text-center mt-4'>
                                    <span onClick={handleSubmitAns} className='btn btn-primary'>Save</span>
                                </div>
                </Modal.Body>
            </Modal>

            <Modal
                size="lg"
                show={paymentModal}
                animation={false}
                centered>

                <Modal.Header>
                    <Modal.Title>Payments</Modal.Title>
                    <span className="modal_close" onClick={handleCloseModal}><i className="icon-cross" /></span>
                </Modal.Header>

                <Modal.Body>


                {
                    activePaymentObject?.isEmi?.allEmiRemains?.length ? (
                        <Fragment>
                            <p><b>Select Amount:</b></p>
                            {
                                activePaymentObject?.isEmi.allEmiRemains.filter(mmi => mmi.status !== 1).map(emi => (
                                    <div onClick={() => (setEmiObj(emi), setAmount(emi.emiAmount))} key={emi._id} className={`d-flex justify-content-between align-items-center emi_chip ${emi._id === emiObj._id ? 'active' : ''}`}>
                                        <div><date>Date: {moment(emi.emiDate).format('MMM DD, YYYY')}</date></div> -
                                        <div>Amount: <b>${emi?.emiAmount?.toFixed(2)}</b></div>
                                    </div>
                                ))
                            }
                        </Fragment>
                    ) : (
                        <Fragment>
                         <h4>Remaining Amount: ${activePaymentObject?.emiAmount?.toFixed(2)}</h4>
                        </Fragment>
                    )
                    }

                    <div className={`form-group`}>
                        <label>Enter Amount to Pay</label>
                        <NumericInput
                            step={0.1}
                            precision={2}
                            value={amount}
                            className="form-control"
                            min={ 0 } 
                            max={ 100 } 
                            size={ 2 } 
                            onChange={e => setAmount(e)}
                            pattern="[0-9].[0-9][0-9]" />
                    </div>

                    <h5>Select a Payment Option</h5>

                        <div className="row">

                            {
                                creditCardRate.status === 1 ? (
                                    <div className="col-md-6">
                                        <div
                                            className={`payment-gateway-card ${paymentMethod === 1 ? 'active' : ''}`}
                                            onClick={() => (setPaymentMethod(1), setPaymentMethodErr(''))}>
                                            <h4>Credit Card / Debit Card</h4>
                                            <h2>${getWithTaxPrice(creditCardRate, amount)}</h2>
                                            <p>Payment Includes {creditCardRate.percentage}% + {`$${creditCardRate.taxRate}`} Processing Charge</p>
                                        </div>
                                    </div>
                                ) : ''
                            }



                            {
                                achTransferRate.status === 1 ? (
                                    <div className="col-md-6">
                                        <div
                                            className={`payment-gateway-card ${paymentMethod === 3 ? 'active' : ''}`}
                                            onClick={() => (setPaymentMethod(3), setPaymentMethodErr(''))}>

                                            <h4>Internet Banking</h4>
                                            <h2>${getWithTaxPrice(achTransferRate, amount)}</h2>
                                            <p>Payment Includes {achTransferRate.percentage}% + {`$${achTransferRate.taxRate}`} Processing Charge</p>
                                        </div>
                                    </div>
                                ) : ''
                            }


        
                        </div>


                        {paymentMethodErr ? <p className="color_red">{paymentMethodErr}</p> : ''}


                



                        {
                            (paymentMethod === 1) ? (
                                <Fragment>
                                <div>
                                    <div className='mb-2'>

                                        <div className="check_box_wrapper cm_dark_check pt-1 ">
                                            <label>Show deleted cards</label>
                                            <input
                                                checked={showDeletedCards}
                                                onChange={() => setShowDeletedCards(!showDeletedCards)}
                                                type="checkbox"
                                                name="gender"
                                                value="male" />
                                            <span className="check_box"><span></span></span>
                                        </div>

                                    </div>
                                    <ul className="card_list">
                                        {loader ?
                                            <div className="program_loader"><ProgramLoader /></div>
                                            :
                                            (cardList.length ? cardList.map(item => (
                                                <li key={item.signature} className={customerPaymentProfileId === item.card.token ? 'active' : ''} style={{ justifyContent: 'space-between' }}>
                                                    <CreditCard
                                                        item={item}
                                                        customerPaymentProfileId={customerPaymentProfileId}
                                                        setCustomerPaymentProfileId={setCustomerPaymentProfileId}
                                                        setCustomerPaymentProfileIdErr={setCustomerPaymentProfileIdErr}
                                                        handlePrimaryCard={handlePrimaryCard}
                                                        handleDeleteCard={handleDeleteCard}
                                                    />
                                                </li>

                                            )) : '')
                                        }
                                    </ul>

                                </div>
                       

                                    {customerPaymentProfileIdError ? <p className="color_red text-center">{customerPaymentProfileIdError}</p> : ''}


                                {
                                    isNewCard ? (
                                    <AddNewCard
                                        setIsNewCard={setIsNewCard}
                                        email={userEmail}
                                        userId={userId}
                                        getCards={getCards}
                                        setResErr={setResErr}
                                        campCode={props.campCode}
                                  />
                                    ) : <button className="btn btn-primary mb-3" onClick={() => setIsNewCard(true)}>Add New Card</button>
                                } 
                            </Fragment>
                            ) : ''
                        }





{    
                            paymentMethod === 3 ? (
                                <Fragment>
                                    <div className="card_inputs add_card_form">
                                    <CustomDropDown
                                        className="form-group"
                                        label={'Select Account Type'}
                                        error={bankAccountTypeErr}
                                        onChange={e =>{setBankAccountType(e);setBankAccountTypeErr('')}}
                                        options={accountTypes}
                                    />


                                        <div className="form-group">
                                            <label>Routing Number</label>
                                            <input
                                                type='number'
                                                className={`form-control ${routingNumberErr ? 'is-invalid' : ''}`}
                                                value={routingNumber}
                                                placeholder="Routing Number"
                                                name="routingNumber"
                                                onChange={e => (setRoutingNumber(e.target.value), setRoutingNumberErr(''))} />

                                            {routingNumberErr ? <OverlayTrigger placement="left" overlay={<Tooltip>{routingNumberErr}</Tooltip>}><i className="input_info" /></OverlayTrigger> : ''}

                                        </div>

                                        <div className="form-group">
                                            <label>Account Number</label>
                                            <SecureInput
                                                type='number'
                                                error={bankAccountNumErr}
                                                value={bankAccountNum}
                                                name={"bankAccountNum"}
                                                placeholder={"Account Number"}
                                                maxLength={30}
                                                onChange={handleBankAccountNumberChange}
                                            />

                                            {bankAccountNumErr ? <OverlayTrigger placement="left" overlay={<Tooltip>{bankAccountNumErr}</Tooltip>}><i className="input_info" /></OverlayTrigger> : ''}

                                        </div>





                                        <div className="form-group">
                                            <label>Account Holder Name</label>
                                            <input
                                                type="text"
                                                className={`form-control ${nameOnAccountErr ? 'is-invalid' : ''}`}
                                                name="nameOnAccount"
                                                value={nameOnAccount}
                                                onChange={e => {setNameOnAccount(e.target.value); setNameOnAccountErr('')}}
                                                placeholder="Account Holder Name" />

                                            {nameOnAccountErr? <OverlayTrigger placement="left" overlay={<Tooltip>{nameOnAccountErr}</Tooltip>}><i className="input_info" /></OverlayTrigger> : ''}
                                        </div>

                                        </div>   
                            </Fragment>
                            ) : ''
                        }

                        {errorMsg ? <p className="color_red">{errorMsg}</p> : ''}
                            <div className="d-flex justify-content-between mt-5">
                                <span onClick={handleCloseModal} className="btn btn-info rounded-0 w-100 me-2">Cancel</span>
                                <span onClick={() => btnLoader ? null : handleCreateBooking()} className={`btn btn-primary rounded-0 w-100  ${btnLoader ? 'btnLoader' : ''}`}>Pay</span>
                            </div>

                </Modal.Body>
            </Modal>

            <Modal
                dialogClassName="h_auto"
                show={isViewAddProducts}
                animation={false}
                size="lg"
                backdrop="static"
                centered>
                <Modal.Body>
               { 
               loading ? 
               <div className="program_loader"><ProgramLoader /></div> :                  
                    <div className="p-2 py-5 product_moda input_err_pos">
                        <span className="modal_close" onClick={handleAddCloseModal}><i className="icon-cross" /></span>

                        <div className='row'>
                            <div className='col-lg-5'>
                            {
                                activeAddProduct?.image?.length ? <Slider {...setting}>
                                                        {activeAddProduct?.image.map(img => (
                                                                <img src={img} className="img-fluid" alt=""/>
                                                        ))}
                                                    </Slider> : ''
                            }

        
                            </div>
                            <div className='col-lg-7'>
                                <h3 style={{color: activeAddProduct.textColor || '#000'}}>{activeAddProduct.title}</h3>

                                
                                 <Fragment>


                                    <div className='d-flex justify-content-between align-items-center'>
                                        {getSizes(activeAddProduct.sizes)?.length ? 
                                         <CustomDropDown
                                            className="form-control"
                                            label={'Size'}
                                            error={selectedSizeErr}
                                            placeholder="Select Size"
                                            value={getSizes(activeAddProduct.sizes).find(i => i.value === selectedSize)}
                                            onChange={e => {setSelectedSize(e.value); setSelectedSizeErr(''); setSelectedColor('')}}
                                            classNamePrefix="cm_select"
                                            options={getSizes(activeAddProduct.sizes)} 
                                            divClass='form-group w-100 me-2'
                                        />
                                         : ''}

                                        {
                                            getColors2(activeAddProduct.sizes, selectedSize)?.length ? 
                                            <CustomDropDown
                                                className="form-control"
                                                label={'Color'}
                                                error={selectedColorErr}
                                                classNamePrefix="cm_select"
                                                divClass='form-group w-100'
                                                isDisabled={(getSizes(activeAddProduct.sizes).length && !selectedSize) ? true : false}
                                                placeholder="Select Color"
                                                value={getColors2(activeAddProduct.sizes, selectedSize).find(i => i.value === selectedColor)}
                                                onChange={e => {setSelectedColor(e.value); setSelectedColorErr('')}}
                                                options={getColors2(activeAddProduct.sizes, selectedSize)} 
                                            />
                                            
                                            : ''
                                        }                                       

                                        
                                    </div>


                                    <div className="quantity mb-4 mt-0">
                                        <button onClick={() => handleAddToCartCountChange('remove')} className="inc"></button>
                                        <b>{currentCount}</b>
                                        <button onClick={() => handleAddToCartCountChange('add')} className="dec"></button>
                                    </div>

                                </Fragment>

                                <div className='d-flex justify-content-between align-items-center mb-3'>
                                    

                                    <div className="product_price">
                                        <h2><b>Item Price: ${activeAddProduct?.price?.toFixed(2)}</b></h2>
                                    </div>
                                    <div className="product_price" >
                                        <h2><b>Total Price: ${calculateTotalProductPrice().toFixed(2)}</b></h2>
                                </div>

                                    
                                </div>
                                {existingWarning && <span className="p_cat_text  p-2">{existingWarning}</span>}
                                <div className=''>
                                    {getHtml(activeAddProduct.desc)}
                                </div>
                                
                                <div className='mt-4 d-flex justify-content-end'>
                                  {   isProductInCart(activeAddProduct._id)? (
                                    <>
                                    <button onClick={() => handleRemoveToCartProduct(activeAddProduct, -1)} className="btn btn-danger btn-sm">REMOVE</button>
                                    <button onClick={() => updateCartItemsProducts(activeAddProduct)} className="btn btn-primary btn-sm ms-3" >UPDATE</button>
                                    </> ):
                                  <button className="btn btn-primary btn-sm" onClick={() => handleAddToCartProduct(activeAddProduct)}>ADD TO CART</button>
                                  }
                                </div>
                                    
                                </div>
                                {
                                    (activeAddProduct && activeAddProduct?.subItems?.length > 0) &&  
                                    <div className='col-sm mt-3'>
                                    <h4>Add-ons</h4>
                                    <div className ="container">
                                        <div className="row">
                                            {       
                                            activeAddProduct?.subItems?.map(item => 
                                                (<Addon 
                                                    key={item._id} 
                                                    item={item} 
                                                    updateAddons={addAddonsToList}
                                                    count = {item?.count}
                                                    sizes= {item?.selectedSize}
                                                    colors = {item?.selectedColor}
                                                    />))
                                            }
                                        </div>
                                    </div>
                                    
                                    </div>
                                }
                            </div>
                       
                    </div>}
                </Modal.Body>
            </Modal>

            <Modal
                dialogClassName="h_auto"
                show={campRelatedProductsModal}
                animation={false}
                size='xl'
                centered>
                    <Modal.Header>
                        <Modal.Title>Product List</Modal.Title>
                        {passDataArr.length ? <span onClick={handleCheckout} className='btn btn-primary cm_Checkout_btn'>Checkout</span> : ''}
                        
                        <span className="modal_close" onClick={handleCloseModal}><i className="icon-cross" /></span>
                    </Modal.Header>
                <Modal.Body>
                    <div className="p-2 d_prodcut_list">
                        {//Here make changes to 
                            campRelatedProducts.map((item, itemIndex) => (
                                <div className='row camp_related_product' key={item._id}>
                                    <div className='col-lg-1' />
                                    <div className='col-lg-3'>
                                    {
                                        item?.image?.length ? 
                                        <Slider {...setting}>
                                                {item?.image.map(img => (
                                                        <img src={img} className="img-fluid"  key={`${img}`} alt='products'/>
                                                ))}
                                        </Slider> : ''
                                    }

                
                                    </div>
                                    <div className='col-lg-1' />
                                    <div className='col-lg-7'>
                                
                                        <h3 style={{color: item.textColor || '#000'}}>{item.title}</h3>
                                            <div className="mb-3">
                                                <b>Count : {item.count}</b>  
                                            </div>
                                        { passDataArr.find(p => p.itemId === item._id)?.subItems?.length > 0
                                        &&
                                        isAllSubitemsCountNonZero(item._id)
                                        && 
                                            <>
                                                <h4 style={{color: item.textColor || '#000'}}>Add-ons</h4>
                                                {
                                                    item.subItems.map(subItem => 
                                                    subItem?.count > 0 && 
                                                        <div className="mb-1">
                                                            <span className='me-5'>{subItem.title}  </span>   
                                                            <b>Count : {subItem.count}</b>  
                                                        </div>                                                   
                                                )
                                                }
                                            </>
                                        }


                                        <div className='d-flex justify-content-between align-items-center mb-3'>
                                            
                                            <div className="">
                                                {
                                                    isProductInCart(item._id)? (
                                                        <button onClick={() => handleRemoveToCartProduct(item, itemIndex)} className="btn btn-danger btn-sm">REMOVE</button>
                                                    ) : (
                                                        <button onClick={() => handleShowModalProductDetail(item, itemIndex)} className="btn btn-primary btn-sm">ADD</button>
                                                    )
                                                }
                                            
                                            </div>

                                            <div className="product_price">
                                                <h2><b>Price: ${((item?.price * item?.count) + getSubItemPrice(item?._id)).toFixed(2)}</b></h2>
                                            </div>
                                        </div>

                                        {/* <div className=''>
                                            {getHtml(item.desc)}
                                        </div> */}
                                    </div>
                                </div>
                            ))
                        }
                    </div>
                </Modal.Body>
            </Modal>


            <Modal
                dialogClassName="h_auto"
                show={productCheckoutModal}
                animation={false}
                size='lg'
                centered
            >
                <Modal.Body>
                    <span className="modal_close" onClick={() => setProductCheckoutModal(false)}><i className="icon-cross" /></span>
                    {productCheckoutModal ? <ProductPaymentGateway passData={passDataArr} userId={userId} userEmail={userEmail} callback={handleBookingSubmit} /> : ''}
                    
                </Modal.Body>
            </Modal>

                <Modal
                    dialogClassName="h_auto"
                    show={insuranceModal}
                    animation={false}
                    size='xl'
                    centered
                >
                <Modal.Body>
                    <span className="modal_close" onClick={() => setInsuranceModal(false)}><i className="icon-cross" /></span>
                    <div className='p-5'>
                    {insuranceModal && ( 
                         <AddInsurance 
                            couponMoney={allData?.couponValue}
                            allData={allData} 
                            userEmail={userEmail} 
                            programId={programId} 
                            userId={userId}
                            programDetails={programDetails}
                            addedinsurance={addedinsurance}
                            additionalExperience={additionalExperience}
                            callBack= {InsurancePurchaseCallback}
                            camperId={camperId}
                            setInsuranceModal={setInsuranceModal}
                            showInsurance={showInsurance}
                        />
                    )}
                    </div>
                    
                </Modal.Body>
            </Modal>

            <Modal
                show={confirmCancelProductModal}
                animation={false}
                centered>
                <Modal.Body>
                    <span className="modal_close" onClick={handleProductActionModal}><i className="icon-cross" /></span>
                    <div className='text-center p-4'>
                    {isOldBooking ?
                        ((productCancellationType.value === 3 || productCancellationType.value === 4 ) && (activeProductData.purchaseType !== 2) && <h4>Refundable amount: ${calculateProductRefundPrice(activeProductData)?.toFixed(2)}</h4>)
                        :
                        ((productCancellationType.value === 3 || productCancellationType.value === 4 ) &&
                        <h4>
                            Refundable amount: ${getProductDisplayRefundAmount(activeProductData, productRefundAmount)?.toFixed(2)}{' '}
                            <OverlayTrigger
                                placement="top"
                                delay={{ show: 250, hide: 400 }}
                                overlay={<Tooltip>This amount includes the application fee</Tooltip>}>
                                <span style={{ display: 'inline-block', width: 16, height: 16, verticalAlign: 'top', marginTop: 0, marginLeft: 6, cursor: 'pointer' }}><InformationIcon color="#842014"/></span>
                            </OverlayTrigger>
                        </h4>
                        )
                    }
                        <label>Select Action Type</label>
                        <div className="form-group">
                            <ReactSelect
                            className="form-control"
                            placeholder="Select Action Type"
                            classNamePrefix="cm_select"
                            value={productCancellationType}
                            onChange={e => (setProductCancellationType(e))}
                            options={cancellationOptions} />
                        </div>

                        {ENABLE_SPECIFIC_INSTALLMENT_PRODUCT_REFUND && !isOldBooking && activeProductData.purchaseType === 2 && hasMultipleProductInstallments() && (productCancellationType.value === 3 || productCancellationType.value === 4) &&
                            <div className="form-group">
                            <label>Refund Type</label>
                                <ReactSelect
                                className="form-control"
                                classNamePrefix="cm_select"
                                value={productRefundMode}
                                onChange={handleProductRefundModeChange}
                                options={productRefundModeOptions} />
                            </div>
                        }
                        {ENABLE_SPECIFIC_INSTALLMENT_PRODUCT_REFUND && !isOldBooking && activeProductData.purchaseType === 2 && hasMultipleProductInstallments() && productRefundMode.value === 'specific' && (productCancellationType.value === 3 || productCancellationType.value === 4) &&
                            <div className="form-group">
                            <label>Select Installment</label>
                                <ReactSelect
                                className="form-control"
                                placeholder="Select Installment"
                                classNamePrefix="cm_select"
                                value={selectedProductRefundTransaction?.value ? selectedProductRefundTransaction : null}
                                onChange={handleProductRefundTransactionChange}
                                options={getRefundInfoTransactions().map(t => ({label: `${t.isInitialPayment ? 'Initial Payment' : 'Installment'} ${t.transactionId} - $${t.total.feeInclusive.toFixed(2)}`, value: t.transactionId}))} />
                            </div>
                        }

                        {(productCancellationType.value === 3 || productCancellationType.value === 4) &&
                        (isOldBooking ?
                            (activeProductData.purchaseType !== 2 ?
                            <Fragment>
                                    <div className='form-group'>
                                    <label>Enter Refund Amount</label>
                                        <NumericInput
                                            className="form-control"
                                            formatter={value => `$${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                                            onChange={(e) => handleProductRefundAmount(e)}
                                            value={productRefundAmount}
                                            min={0}
                                            precision={2}
                                            error={productRefundAmountErr}
                                            />
                                            {productRefundAmountErr && <span className='text-danger mt-2'>{productRefundAmountErr}</span>}
                                    </div>
                            </Fragment>
                            :
                            <p><b>Note: </b><small>You can manually adjust the refund amount in the booking, and you can only change the product status from this section.</small></p>
                            )
                            :
                            <Fragment>
                                    <div className='form-group'>
                                    <label>Enter Refund Amount</label>
                                        <small className='d-block text-muted mb-1'>Max amount: ${getProductMaxRefundableBase(activeProductData)?.toFixed(2)}</small>
                                        <NumericInput
                                            className="form-control"
                                            formatter={value => `$${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                                            onChange={(e) => handleProductRefundAmount(e)}
                                            value={productRefundAmount}
                                            min={0}
                                            precision={2}
                                            error={productRefundAmountErr}
                                            />
                                            {productRefundAmountErr && <span className='text-danger mt-2'>{productRefundAmountErr}</span>}
                                    </div>
                            </Fragment>
                        )
                        }
                        <div className="d-flex justify-content-center mt-5 mb-4">
                                <button className={`btn btn-primary rounded-0  btn_anim ${btnLoader ? 'show_anim' : ''}`} onClick={btnLoader ? null : handleProductCancelRefundAction}>PROCEED</button> 
                                
                        </div>
                    </div>
                </Modal.Body>
            </Modal>

            <Modal
                show={activeForm.camperId}
                centered
                size='xl'
                dialogClassName="remove_header_line">

                <Modal.Header>
                <span className="modal_close" onClick={() => setActiveForm({})}><i className="icon-cross" /></span>
                </Modal.Header>
                <Modal.Body>
                    <div className='embed_div'>
                         <PdfViewer fileUrl={activeForm.url}/>
                    </div>

                    

                
                    <div className="d-flex mt-3">
                        <button onClick={() => setActiveForm({})} className="btn btn-dark w-100">Cancel</button>
                        {
                            activeForm.viewType ? '' : <button onClick={updateBookingKey} className="btn btn-primary w-100 ms-3">I Agree</button>
                        }
                        
                    </div>

                </Modal.Body>
            </Modal>

            <Modal
                            dialogClassName="h_auto"
                            show={amountUpdateModal}
                            animation={false}
                            centered
                        >
                             <Modal.Header>
                                <Modal.Title>Update Amount</Modal.Title>
                                <span className="modal_close" onClick={() => (setAmountUpdateModal(false), setEmiId(''), setNote(''))}><i className="icon-cross" /></span>
                            </Modal.Header>
                        <Modal.Body>
                            <div className="p-2">
                                <div className={`form-group`}>
                                    <label>Amount</label>
                                    <CustomNumber
                                        formatter={value => `$${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                                        change={e => setRemainingAmount(e)}
                                        value={remainingAmount}
                                        min={0}
                                        precision={remainingAmount ? 2 : 0}
                                        pHolder={`Amount`}
                                    />
                                </div>


                                <div className={`form-group`}>
                                    <label>Note</label>
                                    <input
                                        type='text'
                                        className='form-control'
                                        value={note}
                                        onChange={e => (setNote(e.target.value), setNoteErr(''))}
                                    />

                                    {noteErr ? <h6 className='cm_err'>{noteErr}</h6> : ''}
                                </div>
                                

                                <span onClick={() => remainingAmountLoader ? null : handleUpdateAmount()} className='btn btn-primary'>Update</span>
                            </div>
                        </Modal.Body>
            </Modal>

            <Modal
                dialogClassName="h_auto"
                show={updateEMIDateModal}
                animation={false}
                centered
            >
                    <Modal.Header>
                    <Modal.Title>Update Date</Modal.Title>
                    <span className="modal_close" onClick={() => (setUpdateEMIDateModal(false), setActiveEMI(''))}><i className="icon-cross" /></span>
                </Modal.Header>
            <Modal.Body>
                <div className="p-2">

                    <div className={`form-group`}>
                        <label>Select Date</label>
                        <DatePicker
                            disabledDate={disabledDate}
                            value={selectEmiDate}
                            className="form-control"
                            placeholder="Select Date"
                            format="MM/DD/YYYY"
                            onChange={e => setSelectEmiDate(e)} />
                    </div>
                    

                    <span onClick={handleEMIDateChange} className='btn btn-primary'>Update</span>
                </div>
            </Modal.Body>
            </Modal>

            <Modal
                    show={isDeletePopup || isSwitchPrimaryCard}
                    animation={false}
                    dialogClassName="folder_model"
                    size="lg"
                    centered
                        >
                        {isSwitchPrimaryCard && 
                            <Modal.Body>
                            <span className="modal_close" onClick={() => { setIsSwitchPrimaryCard(false) }}><i className="icon-cross" /></span>
                            <div className="text-center p-5 pickup_modal_body">
                                <p>Are you sure you want to change your primary card ?</p>
                            </div>
                            <div className="text-center p-5">
                                <button onClick={() => { setPrimaryCardId(''); setIsSwitchPrimaryCard(false) }} style={{ width: '120px' }} className="btn btn-light rounded-0">No</button>
                                <button onClick={handlePrimaryCardAction} style={{ width: '120px' }} className="btn btn-primary ms-3">Yes</button>
                            </div>
                            </Modal.Body>
                        
                        }
                        { isDeletePopup && 
                        <Modal.Body>
                        <span className="modal_close" onClick={() => { setIsDeletePopup(false) }}><i className="icon-cross" /></span>
                        <div className="text-center p-5 pickup_modal_body">
                            <p>Are you sure you want to remove this card ?</p>
                        </div>
                        <div className="text-center p-5">
                            <button onClick={() => { setDeleteCardToken(''); setIsDeletePopup(false) }} style={{ width: '120px' }} className="btn btn-light rounded-0">No</button>
                            <button onClick={deleteCardAction} style={{ width: '120px' }} className="btn btn-primary ms-3">Yes</button>
                        </div>
                        </Modal.Body>
                
                        }
            </Modal>

            <Modal
                dialogClassName="h_auto"
                show={isViewProducts}
                animation={false}
                onHide={handleCloseProductModal}
                centered>
                <Modal.Body>
                    <span className="modal_close" onClick={handleCloseProductModal}><i className="icon-cross" /></span>
                <ShowProductInfo activeProduct={activeProduct}/>
            </Modal.Body>
            </Modal>
            <ChargeCamperModal
                modalState={modalState}
                chargeModal={chargeModal}
                handleCloseChargeModal={handleCloseChargeModal}
                handleCamperChange={handleCamperChange}
                handleChargeAmountReason={handleChargeAmountReason}
                handleChargeAmountChange={handleChargeAmountChange}
                userId={userId}
            />

            <PaymentModal
                    showModal={showPaymentModal} //Show Modal 
                    handleCloseModal={handleCloseShowPayementModal} //CloseModal Methods
                    amount={activeProduct?.paymentPrice || 0}
                    creditCardRate={creditCardRate}
                    achTransferRate={achTransferRate}
                    cardList={cardList}
                    userEmail={userEmail}
                    handleDeleteCard={handleDeleteCard}
                    userId={userId}
                    getCards={getCards}
                    campCode={props.campCode}
                    purchaseId={activeProduct.purchaseId}
                    bookingId={activeProduct.bookingId}
                    productId={activeProduct.itemId}
                    handlePrimaryCard={handlePrimaryCard}
                    setShowDeletedCards={(p) => setShowDeletedCards(p)}
                    showDeletedCards={showDeletedCards}
            />
            <NoteModal
                show={isCommuterModal}
                handleClose={setIsCommuterModal}
                handleUpdate={toggleCommuter}
            />
            {isCommuterHistory?.length > 0 &&
                <CommuterHistory
                    show={isCommuterHistoryModal}
                    setShow={setIsCommuterHistoryModal}
                    history={isCommuterHistory}
                    timezone={userTimeZone}
                />
            }
            { programDetails?.additionalExp?.length > 0 && additionalExpAudit?.length > 0 &&
                <AdditionalExpAudit
                    show={isAdditionalExpAuditModal}
                    setShow={setIsAdditionalExpAuditModal}
                    history={additionalExpAudit}
                    timezone={userTimeZone}
                    additionalExpData={programDetails?.additionalExp}
                />
            }
            {allData?.userId &&
                <AddNoteModal
                    show={isAddNoteModal}
                    onClose={() => setIsAddNoteModal(false)}
                    userId={allData.userId}
                    campCode={props.campCode}
                    bookingNumber={allData.bookingNumber}
                    bookingPath={window.location.pathname}
                    participantName={[allData?.campers?.firstName, allData?.campers?.lastName].filter(Boolean).join(' ')}
                    programName={allData?.campers?.programName}
                />
            }
            {allData &&
                <AuditTrail
                    show={isAuditTrailModal}
                    setShow={setIsAuditTrailModal}
                    title="Booking Audit Trail"
                    entries={[...(allData.audits || [])].sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt)).map(formatBookingAuditEntry)}
                    timezone={userTimeZone}
                />
            }
            {programDetails?.additionalExp  && 
                <AddExp
                    show={addExpAction === 1 && addExpModal}
                    setShow={setaddExpModal} 
                    detail={{programId, camperId, bookingId}}
                    data={JSON.parse(JSON.stringify(programDetails?.additionalExp))}
                    refresh= {refresh}
                />
            }
            <ConfirmAddExp
                show={addExpAction === 2 && addExpModal}
                setShow={setaddExpModal} 
                detail={{programId, camperId, bookingId}}
                data={programDetails?.additionalExp}
                refresh= {refresh}
                activeAddExp={activeAddExp}
            />
            <ScheduleEmi
                deleteAction={deleteEmi}
                emiId={activeEMI?._id}
                bookingId={bookingId}
                show={emiAction}
                setShow={closeScheduleEmiModal} 
            />
        </div>
    )
}


const mapStateToProps = state => {
    let { preList } = state.program;
    let { saveCabinId, isTeamsEZ } = state.ui;
    let { category, subcategory } = preList;
    let { userProfile } = state.user;
    let { campCode } = userProfile;
    let {timezone} = userProfile
    return {
        category,
        saveCabinId,
        isTeamsEZ,
        campCode,
        subcategories: subcategory,
        userProfile,
        timezone
    };
  }
  

const mapDispatchToProps = dispatch => ({
    saveCabinIdAction: params => dispatch(saveCabinIdAction(params)),
    bookingUserChatAction: params => dispatch(bookingUserChatAction(params)),
});


const ConnectedCamperDetail = connect(mapStateToProps, mapDispatchToProps)(CamperDetail);

// Moving to another booking (Prev / Next) keeps this route matched, so React Router would keep the
// component mounted: the []-effects that load the booking never re-run and the old booking stays on
// screen. Keying on the params remounts it instead, which also resets its ~140 pieces of local state.
const CamperDetailByBooking = props => {
    const { bookingId, camperId, programId } = props.match.params;
    return <ConnectedCamperDetail key={`${bookingId}/${camperId}/${programId}`} {...props} />;
};

export default CamperDetailByBooking;